import { OfOne, createOne } from '@fullstory/tomato';
export class BackButtonView extends OfOne {
  backBtn: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(this.backBtn = createOne('a', doc).setAttr('class', 'backBtn'));
  }
}



export class ConfirmationPopupView extends OfOne {
  heading: OfOne;
  subText: OfOne;
  confirm: OfOne;
  cancel: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'confirmationPopup')
      .append(this.heading = createOne('div', doc).setAttr('class', 'heading'))
      .append(this.subText = createOne('div', doc).setAttr('class', 'subText'))
      .append(this.confirm = createOne('button', doc).setAttr('class', 'submitBtn').appendText('Confirm'))
      .append(this.cancel = createOne('button', doc).setAttr('class', 'cancelBtn').appendText('Cancel'));
  }
}



export class DeleteUserDialogView extends OfOne {
  centeredComponent: OfOne;
  titleText: OfOne;
  userName: OfOne;
  cancelButton: OfOne;
  numSessions: OfOne;
  userNameDeleting: OfOne;
  actionButton: OfOne;
  userNameButton: OfOne;
  subText: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'centeringContainer')
      .append(this.centeredComponent = createOne('div', doc).setAttr('class', 'DeleteUserDialog')
        .append(createOne('div', doc).setAttr('class', 'dialogHeader')
          .append(this.titleText = createOne('div', doc).setAttr('class', 'titleText')
            .append(this.userName = createOne('span', doc).setAttr('class', 'fs-hide')))
          .append(this.cancelButton = createOne('div', doc).setAttr('class', 'cancelButton')))
        .append(createOne('div', doc).setAttr('class', 'dialogContent').appendText('      Deleting this user will:      ')
          .append(createOne('ul', doc).setAttr('class', 'dialogList')
            .append(createOne('li', doc).setAttr('class', 'dialogListItem').appendText('          Permanently erase ')
              .append(createOne('span', doc).setAttr('class', 'numSessions')
                .append(this.numSessions = createOne('span', doc)).appendText('.')))
            .append(createOne('li', doc).setAttr('class', 'dialogListItem').appendText('Remove any data record of this user in your account.'))))
        .append(createOne('div', doc).setAttr('class', 'dialogContentDeleting')
          .append(this.userNameDeleting = createOne('span', doc).setAttr('class', 'fs-hide')).appendText('’s deletion is already in progress.    '))
        .append(this.actionButton = createOne('div', doc).setAttr('class', 'deleteDialogButton confirm')
          .append(this.userNameButton = createOne('span', doc).setAttr('class', 'userNameButton fs-hide')))
        .append(this.subText = createOne('div', doc).setAttr('class', 'subText centered').appendText('      You will receive an email when deletion is complete.      ')
          .append(createOne('br', doc)).appendText('      This action is permanent and cannot be undone.    ')));
  }
}



export class DetectionsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('id', 'detectionsContainer');
  }
}



export class EmbedAppView extends OfOne {
  embedContentCover: OfOne;
  embedCoverCopy: OfOne;
  tooSmallCta: OfOne;
  container: OfOne;
  footer: OfOne;
  poweredByLink: OfOne;
  intro: TestDriveIntroView;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'EmbedAppView')
      .append(this.embedContentCover = createOne('div', doc).setAttr('class', 'embedContentCover')
        .append(createOne('div', doc).setAttr('class', 'embedContentCoverCopyContainer')
          .append(createOne('h1', doc).appendText('You\'re going to want to see this'))
          .append(this.embedCoverCopy = createOne('span', doc).appendText('        To view this Session and all of its related information,        you\'ll need to resize this container to make it bigger.        Alternatively, you can view this Session Replay directly        in FullStory by clicking the button below.      '))
          .append(this.tooSmallCta = createOne('a', doc).setAttr('target', '_blank').setAttr('rel', 'noreferrer').appendText('View in FullStory')))
        .append(createOne('div', doc).setAttr('class', 'embedContentCoverBrandingContainer')
          .append(createOne('span', doc).appendText('        Powered by       '))
          .append(createOne('span', doc).setAttr('class', 'embedContentCoverBranding').appendText('fullstory'))))
      .append(this.container = createOne('div', doc).setAttr('class', 'container'))
      .append(this.footer = createOne('div', doc).setAttr('class', 'footer')
        .append(createOne('div', doc).setAttr('class', 'powered-by')
          .append(this.poweredByLink = createOne('a', doc).setAttr('target', '_blank').appendText('        Powered by        ')
            .append(createOne('span', doc).setAttr('class', 'branding').appendText('fullstory')))))
      .append(this.intro = <TestDriveIntroView>new TestDriveIntroView(doc));
  }
}



export class FreemiumWelcomeDialogView extends OfOne {
  headerText: OfOne;
  dialogText: OfOne;
  pricingLink: OfOne;
  startButton: OfOne;
  nevermind: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'FreemiumWelcomeDialogContainer')
      .append(createOne('div', doc).setAttr('class', 'freemiumWelcomeDialogContainer')
        .append(createOne('div', doc).setAttr('class', 'top')
          .append(createOne('img', doc).setAttr('src', '/s/img/fullstorylogo.svg').setAttr('class', 'fullstorylogo')))
        .append(createOne('div', doc).setAttr('class', 'bottom')
          .append(this.headerText = createOne('h1', doc))
          .append(createOne('div', doc).setAttr('class', 'dialogText')
            .append(this.dialogText = createOne('span', doc))
            .append(createOne('br', doc))
            .append(this.pricingLink = createOne('a', doc).setAttr('href', 'https://www.fullstory.com/pricing').setAttr('target', '_blank')))
          .append(this.startButton = createOne('div', doc))
          .append(this.nevermind = createOne('div', doc).setAttr('class', 'dialogText nevermind'))
          .append(createOne('div', doc))));
  }
}



export class GtmPublishErrorView extends OfOne {
  tagLink: OfOne;
  normalSetup: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'GtmPublishErrorView').appendText('  We were unable to publish your tag to Google Tag Manager. You can  ')
      .append(this.tagLink = createOne('a', doc).setAttr('href', '#').setAttr('target', '_blank').appendText('view it in GTM')).appendText('  or  ')
      .append(this.normalSetup = createOne('a', doc).setAttr('class', 'continueNormal').setAttr('href', '#').appendText('continue to normal setup')).appendText('.');
  }
}



export class GtmPublishStepView extends OfOne {
  tagUrl: OfOne;
  button: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'GtmPublishStepView')
      .append(createOne('div', doc).appendText('    Happy with your settings? Hit the button below to publish, or    ')
        .append(this.tagUrl = createOne('a', doc).setAttr('href', '#').setAttr('target', '_blank').appendText('view tag in GTM here')).appendText('.  '))
      .append(this.button = createOne('div', doc).setAttr('class', 'publishTag button').appendText('Publish tag and start capturing data'));
  }
}



export class HeatmapsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('id', 'heatmapsContainer');
  }
}



export class HistoryPickerView extends OfOne {
  decrement: OfOne;
  value: OfOne;
  description: OfOne;
  increment: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'HistoryPicker')
      .append(this.decrement = createOne('div', doc).setAttr('class', 'decrement stepBtn').appendText('-'))
      .append(createOne('div', doc).setAttr('class', 'selectedOption')
        .append(this.value = createOne('div', doc).setAttr('class', 'value'))
        .append(this.description = createOne('div', doc).setAttr('class', 'description')))
      .append(this.increment = createOne('div', doc).setAttr('class', 'increment stepBtn').appendText('+'));
  }
}



export class LabeledSliderView extends OfOne {
  recommended: OfOne;
  slider: OfOne;
  bar: OfOne;
  thumb: OfOne;
  label: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'LabeledSlider no-rec')
      .append(this.recommended = createOne('div', doc).setAttr('class', 'recommended').appendText('Our best guess'))
      .append(this.slider = createOne('input', doc).setAttr('type', 'range'))
      .append(this.bar = createOne('div', doc).setAttr('class', 'bar'))
      .append(this.thumb = createOne('div', doc).setAttr('class', 'thumb'))
      .append(this.label = createOne('div', doc).setAttr('class', 'label'));
  }
}



export class LeftRightButtonView extends OfOne {
  leftLabel: OfOne;
  rightLabel: OfOne;
  proIcon: ProIconView;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'leftRightToggle')
      .append(createOne('span', doc).setAttr('class', 'bg'))
      .append(this.leftLabel = createOne('span', doc).setAttr('class', 'label left'))
      .append(this.rightLabel = createOne('span', doc).setAttr('class', 'label right'))
      .append(this.proIcon = <ProIconView>new ProIconView(doc));
  }
}



export class LeftRightPaginationView extends OfOne {
  leftArrow: OfOne;
  current: OfOne;
  ofTxt: OfOne;
  total: OfOne;
  rightArrow: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'LeftRightPagination')
      .append(this.leftArrow = createOne('span', doc).setAttr('class', 'arrow')
        .append(createOne('div', doc).setAttr('class', 'chevron sm left')))
      .append(createOne('span', doc).setAttr('class', 'counts')
        .append(this.current = createOne('span', doc).setAttr('class', 'current')).appendText('     ')
        .append(this.ofTxt = createOne('span', doc).setAttr('class', 'of')).appendText('     ')
        .append(this.total = createOne('span', doc).setAttr('class', 'total')))
      .append(this.rightArrow = createOne('span', doc).setAttr('class', 'arrow')
        .append(createOne('div', doc).setAttr('class', 'chevron sm right')));
  }
}



export class Level0CalloutView extends OfOne {
  header: OfOne;
  msg: OfOne;
  actions: OfOne;
  progress: OfOne;
  next: OfOne;
  done: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'level0Callout')
      .append(this.header = createOne('div', doc).setAttr('class', 'header'))
      .append(this.msg = createOne('div', doc).setAttr('class', 'msg'))
      .append(this.actions = createOne('div', doc).setAttr('class', 'actions')
        .append(this.progress = createOne('div', doc).setAttr('class', 'progress'))
        .append(this.next = createOne('div', doc).setAttr('class', 'next').appendText('Next'))
        .append(this.done = createOne('div', doc).setAttr('class', 'done').appendText('Got it!')));
  }
}



export class Level0IndicatorView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'level0Indicator')
      .append(createOne('div', doc).setAttr('class', 'centered')
        .append(createOne('div', doc).setAttr('class', 'pulse scale')));
  }
}



export class LinearProgressView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'LinearProgress')
      .append(createOne('div', doc).setAttr('class', 'container')
        .append(createOne('div', doc).setAttr('class', 'dashed'))
        .append(createOne('div', doc).setAttr('class', 'bar bar1'))
        .append(createOne('div', doc).setAttr('class', 'bar bar2')));
  }
}



export class MultiOptionButtonView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'MultiOptionButton');
  }
}



export class NotificationView extends OfOne {
  spinner: OfOne;
  msg: OfOne;
  actions: OfOne;
  dismiss: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'notification')
      .append(createOne('div', doc).setAttr('class', 'flag')
        .append(this.spinner = createOne('div', doc).setAttr('class', 'spinner hidden')))
      .append(this.msg = createOne('div', doc).setAttr('class', 'message'))
      .append(this.actions = createOne('div', doc).setAttr('class', 'actions'))
      .append(this.dismiss = createOne('div', doc).setAttr('class', 'dismiss notification-dismiss'));
  }
}



export class NotificationDeleteUserView extends OfOne {
  userName: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(this.userName = createOne('span', doc).setAttr('class', 'fs-hide')).appendText(' is being deleted.');
  }
}



export class NotificationTrayView extends OfOne {
  notifications: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'notificationTray')
      .append(this.notifications = createOne('div', doc).setAttr('class', 'notifications'));
  }
}



export class ProIconView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ProIcon').appendText('Pro');
  }
}



export class ProIconListView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ProIconList').appendText('Pro');
  }
}



export class ProIconNavView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ProIconNav').appendText('Pro');
  }
}



export class RadioInputView extends OfOne {
  input: OfOne;
  visualInput: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('span'));

    this.setAttr('class', 'RadioInput')
      .append(this.input = createOne('input', doc).setAttr('type', 'radio'))
      .append(this.visualInput = createOne('span', doc).setAttr('class', 'visual'));
  }
}



export class SegmentFlowLastStepView extends OfOne {
  bail: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SegmentFlowLastStepView')
      .append(createOne('div', doc).appendText('    With Segment authorized you should see captured data immediately. Segment integration a little bumpy? No problem.    ')
        .append(this.bail = createOne('span', doc).setAttr('class', 'bail').appendText('Continue to normal setup.')));
  }
}



export class SegmentFlowSetupStepView extends OfOne {
  segmentButton: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SegmentFlowSetupStepView')
      .append(createOne('span', doc).appendText('Visit Segment.com to enable FullStory data capture for your site.'))
      .append(this.segmentButton = createOne('div', doc).setAttr('class', 'segment-btn'));
  }
}



export class SupportPickerView extends OfOne {
  supportPicker: OfOne;
  selectionContainer: OfOne;
  helpLabel: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(this.supportPicker = createOne('div', doc).setAttr('class', 'SupportPicker')
        .append(this.selectionContainer = createOne('div', doc).setAttr('class', 'selectionContainer')
          .append(createOne('div', doc).setAttr('class', 'selection')
            .append(this.helpLabel = createOne('div', doc).setAttr('class', 'selectedState helpBtn')))));
  }
}



export class SupportWidgetView extends OfOne {
  button: OfOne;
  popup: OfOne;
  close: OfOne;
  proFeature: OfOne;
  proIcon: OfOne;
  kbLink: OfOne;
  form: OfOne;
  subject: OfOne;
  body: OfOne;
  send: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SupportWidgetView')
      .append(this.button = createOne('button', doc).setAttr('class', 'openClose').setAttr('title', 'FullStory Support').appendText('?'))
      .append(this.popup = createOne('div', doc).setAttr('class', 'popup')
        .append(createOne('div', doc).setAttr('class', 'support-header')
          .append(createOne('span', doc).setAttr('class', 'left').appendText('Contact Support'))
          .append(createOne('a', doc).setAttr('href', 'https://help.fullstory.com/').setAttr('target', '_blank').setAttr('class', 'center').appendText('Knowledge Base'))
          .append(this.close = createOne('a', doc).setAttr('href', '#').setAttr('class', 'closePopup')))
        .append(this.proFeature = createOne('div', doc).setAttr('class', 'proFeature')
          .append(this.proIcon = createOne('div', doc).setAttr('class', 'fsProLogo'))
          .append(createOne('div', doc).setAttr('class', 'proFeatureText').appendText('        Upgrade to ')
            .append(createOne('b', doc).appendText('FullStory Pro')).appendText(' for a convenient in-app support widget        (and much more). Until then, try the ')
            .append(this.kbLink = createOne('a', doc).setAttr('href', 'https://help.fullstory.com/').setAttr('target', '_blank').appendText('FullStory Knowledge Base')).appendText('.      ')))
        .append(this.form = createOne('div', doc).setAttr('class', 'supportForm')
          .append(createOne('div', doc).setAttr('class', 'subjectContainer')
            .append(this.subject = createOne('input', doc).setAttr('type', 'text').setAttr('placeholder', 'Subject').setAttr('autofocus', '')))
          .append(createOne('div', doc).setAttr('class', 'bodyContainer')
            .append(this.body = createOne('textarea', doc).setAttr('placeholder', 'How can we help?')))
          .append(createOne('div', doc).setAttr('class', 'support-footer')
            .append(this.send = createOne('button', doc).setAttr('class', 'send')))));
  }
}



export class TermsConditionsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'TermsConditionsText')
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Human language: Just before each section we’ve included some words in italics that are not part of the agreement. They are meant to explain in more human terms the intent behind each section. We actually want you to read this stuff, so hopefully these words help you to do just that.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    FullStory, Inc. (“FullStory,” “we,” “us” or “our”) and the person or entity agreeing to these terms (“Customer” or “you”) would like to set out the general terms and conditions for (i) you to access and use the FullStory Services and provide Customer Data to FullStory and (ii) FullStory to provide the Services to you and use the Customer Data when performing the Services.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    BY CLICKING ACCEPT TERMS, YOU ARE AGREEING TO THE TERMS IN THIS AGREEMENT. Customer and FullStory agree that this Agreement along with Customer’s order for the Services (“Order”) is effective on the date Customer orders the Services by clicking the “Accept” button as part of the ordering process, and accepts these terms. If you are entering into this Agreement on behalf of a company or other legal entity, you represent that you have the authority to commit the entity to the Agreement and the term “Customer” or “you” will refer to that entity. If you do not have this authority, are under the age of 18 or if you do not agree with the Agreement, you must not select the “Accept” button or accept these terms and you may not access or use the Services.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    MAKE SURE YOU READ THIS AGREEMENT, THE ORDER, THE PRIVACY POLICY AND THE ACCEPTABLE USE POLICY. IT CONTAINS IMPORTANT INFORMATION ABOUT YOUR RIGHTS TO USE FULLSTORY.    The Order provides the specific terms and conditions regarding Customer’s subscription for the Services, such as User limitations, pricing methodologies and the length of the term FullStory will provide the Services (“Subscription Term”). These terms and conditions, the FullStory Privacy Policy located at ')
        .append(createOne('a', doc).setAttr('href', 'https://fullstory.com/legal/privacy').setAttr('target', '_blank').appendText('https://fullstory.com/legal/privacy')).appendText(' and the FullStory Acceptable Use Policy located at ')
        .append(createOne('a', doc).setAttr('href', 'https://fullstory.com/legal/acceptable-use').setAttr('target', '_blank').appendText('>https://fullstory.com/legal/acceptable-use')).appendText(' in addition to the Order, is the “Agreement” between Customer and FullStory.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 1  This section is an attempt by our legal team to shorten the [already excruciatingly] long agreement by pre-defining some terms and then using them throughout the rest of the document.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      1. 	Definitions.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      In addition to the terms otherwise defined in this Agreement or an Order, the following terms have the definitions below:    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      1.1.   	"Customer Data” means any content, data, information or material that is recorded by, submitted to or stored by, the Services, including, but not limited to, Personal Data.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      1.2.   	“Personal Data” means all information relating to a person that identifies such person or could reasonably be used to identify such person, including but not limited to, as first and last name, home address, billing address, or other physical address, email address, telephone number and Sensitive Data, if any.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      1.3	“Sensitive Data” means any information that: (a) requires a high degree of protection by law and where loss or unauthorized disclosure would require notification by Customer to government agencies, individuals or law enforcement, (b) any information that, if made public, could expose individuals to a risk of physical harm, fraud, or identity theft. Sensitive Data includes, but is not limited to, social security numbers or other government-issued identification numbers, financial account numbers, credit card or debit card numbers, CVVs, credit report information or other personal financial information, health or medical information or other information that is subject to international, federal, state, or local laws or ordinances now or hereafter enacted regarding data protection or privacy, including, but not limited to, the Health Insurance Portability and Accountability Act, the Health Information Technology for Economic and Clinical Health Act, the Fair Credit Reporting Act, the Children’s Online Privacy Protection Act and the Gramm-Leach-Bliley Act    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      1.4.  	 “Services" means the content, features, functionality,  tools, data, software applications and APIs provided by FullStory via ')
          .append(createOne('a', doc).setAttr('href', 'http://fullstory.com').setAttr('target', '_blank').appendText('http://fullstory.com')).appendText(' and/or other designated websites as described in the User Guide, that are ordered by Customer in an Order, as updated from time to time.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      1.5.   	"User Guide" means the online user guide for the Services accessible at help.fullstory.com, as updated from time to time.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      1.6.   	"Users" means individuals who are authorized by Customer to use the Services, for whom subscriptions to the Services have been purchased under an Order, and who have been supplied user identifications and passwords by Customer (or by FullStory, at Customer’s request). Users may include Customer’s employees, consultants, contractors and agents or third parties with which Customer transacts business.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 2 This section lets you know that you don’t own FullStory. Your subscription just gives you the right to use it while you’re a customer.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText tacListItem header').appendText('    2.  	License Grant.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Subject to the terms and conditions of this Agreement and the Order, for the length of the term set forth in the applicable Order, FullStory grants Customer, a non-exclusive, non-transferable, non-assignable (except as set out in Section 17 below), worldwide, limited right to access and use the Services (as such Services may be modified, revised and updated in accordance with this Agreement) for collecting and analyzing web data on Customer’s site(s) and/or native applications, for Customer’s own internal business purpose.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 3 This section explains how we really, really don’t want you to send us sensitive, personal information. If you do so by accident, please let us know so we can help make it right!  '))
      .append(createOne('p', doc).setAttr('class', 'tacText tacListItem header').appendText('    3.  	Customer Data.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Customer agrees that it will not provide any Sensitive Data to FullStory. If Customer discovers that due to human error or otherwise, Customer Data does include Sensitive Data, Customer will promptly notify FullStory and provide sufficient information to FullStory to locate such Sensitive Data and FullStory will scrub its systems and the Sensitive Data in its control or possession. FullStory will maintain appropriate administrative, physical, and technical safeguards for protection of the security, confidentiality and integrity of Customer Data and will comply with the FullStory Privacy Policy. As between Customer and FullStory, Customer owns all Customer Data and except as specifically provided in this Agreement or otherwise agreed to in writing between the parties, FullStory has no right to such Customer Data. Customer grants to FullStory a non-exclusive royalty-free license to access and use Customer Data in order to provide the Services to Customer and as necessary to monitor and improve the Services. FullStory will not (a) disclose Customer Data except as compelled by law or as expressly permitted in writing by you, or (b) access Customer Data except to provide the Services or prevent or address service or technical problems, or at your request in connection with customer support matters. For the avoidance of doubt, FullStory may use, reproduce and disclose Customer Data that is anonymized, de-identified, or is otherwise not reasonably associated or linked to Customer (or any other identifiable individual person or entity) (“Anonymized Data”) for product improvement and other purposes consistent with FullStory’s Privacy Policy. This right to use Anonymized Data will survive termination of this Agreement. Customer, not FullStory, will have sole responsibility for the accuracy, quality, integrity, legality, reliability, appropriateness, and intellectual property ownership or right to use of all Customer Data.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 4 This section addresses confidentiality. We’ve all got confidential information as part of running a business. Please don’t share ours. We absolutely won’t share yours.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem header').appendText('      4.  	Confidentiality.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      4.1.	Confidential Information. Each party (the “Receiving Party”) understands that the other party (the “Disclosing Party”) has business, technical or financial information relating to Disclosing Party’s business which it has disclosed or may disclose during this Agreement (“Confidential Information”). FullStory’s Confidential Information includes non-public information regarding features, functionality and performance of the Services, as well as all user visible aspects of the Services. Customer’s Confidential Information includes information provided by Customer to FullStory to enable the provision of the Services as well as all Customer Data. The terms and conditions of this Agreement, including all pricing and related metrics, are each party’s Confidential Information.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      4.2.  	Non-Use. Receiving Party agrees that it will take reasonable measures to protect the secrecy of and avoid disclosure and unauthorized use of the Confidential Information of Disclosing Party. Without limiting the foregoing, Receiving Party will take at least those measures that it takes to protect its own most important confidential information. Receiving Party agrees (i) not to use any Confidential Information of Disclosing Party for any purpose except to perform its obligations or exercise its rights under this Agreement and (ii) not to disclose any Confidential Information of Receiving Party to third parties or to such party\'s employees, officers, agents, contractors or other representatives (“Personnel”), except to those Personnel of Receiving Party who need or  have access to such Confidential Information in order to perform works in connection with this Agreement and are subject to confidentiality obligations consistent with those of this Agreement.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      4.3.  	Exceptions. Disclosing Party agrees that these confidentiality obligations will not apply to any information that Receiving Party can document (a) is or becomes generally available to the public; (b) was in its possession or known by it prior to receipt from Disclosing Party; (c) was rightfully disclosed to it without restriction by a third party; and/or (d) was independently developed without use of any Confidential Information of Disclosing Party.  Nothing in this Section 4 precludes either party from disclosing the other party’s Confidential Information as required by law or a legal process, provided that such party (a) gives the other party prior written notice sufficient to permit the other party to contest the disclosure or seek a protective order (or other confidential treatment) and (b) reasonably cooperates with the other party in limiting the disclosure. In addition, a party may disclose information concerning this Agreement and the transactions contemplated under this Agreement, including providing a copy of this Agreement, to any or all of the following: (a) potential acquirers, merger partners, investors and their personnel, attorneys, auditors and investment bankers, solely in connection with the due diligence review of such party by persons and provided that the disclosures are made in confidence, (b) the party’s outside accounting firm, or (c) the party’s outside legal counsel.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      4.4.  	Return of Confidential Information. Promptly following the earlier of (i) the expiration or earlier termination of this Agreement, or (ii) the request of Disclosing Party, Receiving Party will return to Disclosing Party, or destroy all Confidential Information that are in written, electronic or other tangible form (including, without limitation, all written or printed documents, notes, memoranda, email, or computer memory, whether or not prepared by Receiving Party) to the extent containing or summarizing any portion of the Confidential Information, including, without limitation, all copies and extracts of such Confidential Information. In addition, upon the request of Disclosing Party, Receiving Party will certify to Disclosing Party in writing Receiving Party’s and its Personnel’s compliance with its obligations pursuant to this Section 4.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      4.5.  	Equitable Remedies. Receiving Party acknowledges that in the event of a breach of this Section 4 by Receiving Party, substantial injury could result to Disclosing Party and money damages will not be a sufficient remedy for such breach. In the event that Receiving Party engages in, or threatens to engage in any act which violates any provision of this Agreement, Disclosing Party will be entitled, in addition to all other remedies which may be available to it under law, to seek injunctive relief (including, without limitation, temporary restraining orders, or preliminary or permanent injunctions) and specific enforcement of the terms of this Agreement. Disclosing Party will not be required to post a bond or other security in connection with the granting of any such relief.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      4.6.  	Redundancy.  Notwithstanding anything to the contrary in this Agreement, FullStory may retain Confidential Information after termination of this Agreement for such period of time agreed to by Customer and FullStory.  To the extent that FullStory is required by law to maintain copies of Confidential Information, Customer Data, or records related to disclosure or handling of Confidential Information, FullStory will be under no obligation to destroy such information. Furthermore, FullStory will be permitted to retain such information, as FullStory reasonably determines necessary to demonstrate to Customer or any regulatory authority, FullStory\'s compliance with this Agreement or any applicable law or regulation. At such time as FullStory\'s basis for retaining such information ceases to exist, FullStory will destroy such information as set forth above.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 5 This section is basically our version of The Golden Rule. If you wouldn’t want us to do it to you, then you probably shouldn’t do it to us. We’ve poured a lot of love and energy into the creation of FullStory, so we’d prefer that you play fair when using our service.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem header').appendText('      5.  	Customer Obligations.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      Except as permitted under this Agreement or as required by law, Customer will not, and will not permit or encourage anyone else, to:    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (i)  license, sublicense, sell, resell, transfer, assign, distribute, use as a service bureau or timeshare, or otherwise commercially exploit or make the Services available to any third party in any way;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (ii) modify, disassemble or make derivative works based upon the Services or otherwise attempt to derive source code or other trade secrets from the Services;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (iii) reverse engineer or access the Services in order to (a) build a competitive product or service, (b) build a product using similar ideas, features, functions or graphics of the Services, or (c) copy any ideas, features, functions or graphics of the Services;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (iv) modify, remove or obstruct any proprietary rights statement or notice contained in the Services;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (v)  send spam or otherwise duplicative or unsolicited messages in violation of applicable laws;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (vi)  send or store (a) infringing, obscene, threatening, libelous, or otherwise unlawful or tortious material, including material harmful to children or which violates third party privacy rights; or (b) material containing software viruses, worms, Trojan horses or other harmful computer code, files, scripts, agents or programs;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (vii) attempt to gain unauthorized access to the Services or its related systems or networks;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (viii) access the Services if you are a direct competitor of FullStory, except if FullStory agrees in writing before you access the Services;    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (ix) use the Services in excess of the number of sessions selected in the applicable Order; or    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      (x) provide false identity information to access or use the Services;    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    This next part addresses shared logins- we don’t take pains to keep you from sharing a seat. But if you do, you are responsible for keeping that shared information secure.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Customer acknowledges that FullStory does not restrict sharing of User accounts and/or passwords and agrees that Customer will be responsible for any liability to the extent arising from such use or sharing of accounts. Customer agrees to comply with all applicable local, state, national and foreign laws, treaties and regulations in connection with Customer’s and its User’s use of the Services but especially those related to data privacy. Customer is responsible for any breach of this Agreement by its Users. Customer agrees that it will promptly notify FullStory of any violation or suspected violation of this Agreement or any actual or suspected data or security breach.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('  FullStory reserves the right to review information posted by Users to ensure that it complies with this or any other section of this Agreement, and to amend it or delete it, or otherwise control such information in order to bring it into compliance with this Agreement and/or applicable law.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 6 This section is about service. We try our darndest to provide top notch customer support and product uptime, but know that we don’t walk on water.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    6.  	Support.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Subject to the terms of this Agreement, FullStory will provide Customer with reasonable technical support services in accordance with FullStory’s standard support offering. Our servers may be unavailable as the result of planned or unplanned downtime, for reasons including technical issues, legal compliance, security actions, business decisions, or any other cause. We may attempt to inform you if such downtime is planned, but we are under no obligation to do so. You agree that we are not liable for the unavailability of our Service.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 7 This section talks about who owns an idea. Our stuff is ours and your stuff is yours. If we build the awesome idea that you submitted as a feature request, that will count as our stuff.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      7.  	Intellectual Property Ownership.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      7.1.   	FullStory IP. Except for the limited right to access and use the Services under this Agreement and the applicable Order, Customer acknowledges and agrees that, as between the parties, FullStory (or its licensors) have and will retain any and all rights, title, and interest in the Services, any software utilized to perform the Services and the User Guides (collectively, the FullStory Products) and all derivative works made by any person or entity in or to the FullStory Products, including, but not limited to, patents, copyrights, trademarks, trade secrets and other intellectual property and proprietary rights (collectively the “Intellectual Property Rights”) associated with the FullStory Products. Customer will not assert or cause any other party (including, without limitation, any User) to assert any right, title, or interest in or to the FullStory Products or other portion of FullStory’s Intellectual Property Rights. Customer grants FullStory a royalty-free, worldwide, transferable, sub-licensable, irrevocable, perpetual license to use or incorporate into its software or services, any suggestions, enhancement requests, recommendations or other feedback provided by Customer, including its Users, relating to FullStory\'s software, services or business operations.  This Agreement is not a sale and except as set forth in this Agreement, does not give Customer any rights of ownership in, or related to, the Services, any FullStory software or the Intellectual Property Rights owned by FullStory.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      7.2.  	Customer IP. Except as set forth in this Agreement, this Agreement does not give FullStory any rights of ownership in, or related to, any Intellectual Property Rights owned by Customer.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 8 This section is about customer privacy and how very, very seriously we take it. Please go read the Privacy Policy and Acceptable Use Policy.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    8.  	Privacy & Security; Disclosure.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Customer agrees to comply with FullStory’s Privacy Policy and Acceptable Use Policy. FullStory reserves the right to modify the FullStory Privacy Policy and Acceptable Use Policy in its reasonable discretion from time to time.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 9 This section is about subscription payments. Please pay your bills, y’all. We can take away our service if you don’t.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      9.  	Payment of Fees.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      9.1.   	Fees. The Services are offered on a subscription basis and payments can be made via credit card. We will bill your credit card at the time and according to the rates and terms which are published on FullStory’s website from time to time and which are incorporated into the Order. Customer may separately subscribe for separately priced modules, as and when released by FullStory. All fees are in U.S. dollars. Customer must provide FullStory with valid credit card information as a condition to signing up for the Services. Customer agrees that FullStory may charge the credit card the fee for the entire Subscription Term unless otherwise agreed to in an Order. FullStory will send notice to you if payment fails for any reason and you agree that you will immediately submit accurate credit card information for processing. It is your responsibility to make sure payment details are correct to prevent Service interruption and to allow successful renewal payments. If Customer believes that FullStory has billed Customer incorrectly, Customer must contact FullStory no later than 60 days after the closing date on the first billing statement in which the error or problem appeared, in order to receive an adjustment or credit. Inquiries should be directed to hugs@fullstory.com. All Fee changes will be made prospectively and any Services that have been pre-purchased will not be affected by the change in Fees. Unless otherwise agreed to by the parties or as set forth on an Order, all Fees for any renewal periods will be based upon FullStory’s then-prevailing rate.  FullStory may choose to bill through an invoice, in which case, full payment for invoices issued in any given month must be received by FullStory within 30 days after the mailing date of the invoice (unless otherwise specified on the Order). Unpaid amounts are subject to a finance charge of 1.5% per month on any outstanding balance, or the maximum permitted by law, whichever is lower, plus all expenses of collection and may result in immediate suspension or termination of Service.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      9.2.  	Taxes. The Fees do not include any taxes, levies, duties or similar governmental assessments of any nature, including, for example, value-added, sales, use or withholding taxes, assessable by any jurisdiction whatsoever (collectively, “Taxes”). Customer is responsible for paying all Taxes associated with its purchases under this Agreement and any Order. If FullStory has the legal obligation to pay or collect Taxes for which Customer is responsible under this Section 9, FullStory will invoice Customer and Customer will pay that amount unless Customer provides FullStory with a valid tax exemption certificate authorized by the appropriate taxing authority.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      9.3. 	Suspension of Service and Acceleration. If any amount owing by Customer under this or any other Agreement with FullStory is ten (10) or more days overdue, FullStory may, without limiting its other rights and remedies, accelerate Customer\'s unpaid fee obligations under such Order so that all such obligations become immediately due and payable, and suspend any and all services until such amounts are paid in full.  Customer will continue to be charged fees during any period of suspension. If Customer or FullStory initiates termination of this Agreement, Customer will be obligated to pay the balance due on Customer’s account. Any use of the Services in violation of the Agreement by Customer that in FullStory’s reasonable judgment threatens the security, integrity or availability of FullStory’s services or that of its other customers, may result in FullStory’s immediately suspending the Services.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 10 This section is about equal rights. You can leave us anytime. And although we really don’t expect this will happen, we reserve the right to leave you, too.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      10.  	Term and Termination    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      10.1. 	Term. This Agreement will commence on its Effective Date and will remain in effect for the term set forth in the Order (“Initial Term”). The Agreement will automatically renew for successive terms equal to the Initial Term (each a “Renewal Term”), unless one party gives notice to the other party of its intent not to renew prior to the expiration of the then current Term. The Initial Term together with any Renewal Term permitted under this Section is the “Term” of this Agreement. If there are any active Orders existing under this Agreement as of the expiration of the Term, which Orders are not otherwise terminated under this Agreement, the Term of this Agreement will continue with respect to an outstanding Order until expiration, termination or completion of each such Order.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      10.2. 	Termination for Breach. Either party may terminate this Agreement or any Order at any time by giving written notice to the other party in the event that the other party is in breach of any of its obligations under this Agreement or any Order and fails to remedy such breach within thirty (30) days after written notice from the other party.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      10.3.	 Termination for Convenience. Customer may terminate an Order for convenience but all payment obligations are non-cancelable and all amounts paid are non-refundable, except in the event of a termination by Customer for breach of the Agreement as set forth in Section 10.2 above.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      10.4.	 Termination for Insolvency. If: (i) a party files a petition under any chapter of the United States Bankruptcy Code (11 U.S.C. §101 et. seq., as amended from time to time, or under any similar law or statute (each, an “Insolvency Statute”); (ii) a petition is filed under any such Insolvency Statute (provided that such petition is not dismissed within thirty (30) days of filing) or such party notifies the other party that such a petition will be filed under an Insolvency Statute; (iii) a party becomes or is declared insolvent, or is unable to pay its debts as they become due; (iv) a party is the subject of any proceedings related to dissolution, liquidation, insolvency or the appointment of a receiver, trustee or similar officer for all or a substantial part of such party\'s assets; or (v) a party makes an assignment for the benefit of all or substantially all of its creditors; then the other party may terminate this Agreement and all Orders as of a date specified in a termination notice.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      10.5. 	Post Termination Obligations. Upon expiration or termination of this Agreement for any reason, FullStory will promptly terminate the Services. FullStory will have no obligation to maintain or provide any Customer Data and may thereafter, unless legally prohibited, delete all Customer Data in its systems or otherwise in its possession or under its control. Sections 1, 4, 7, 9, 10.5, 11.2, 12, 13 and 15 through 18 will survive any termination or expiration of this Agreement. All other rights and obligations will be of no further force or effect. Termination will not relieve either party from any liability arising from any breach of this Agreement. Neither party will be liable to the other for damages of any kind solely as a result of terminating this Agreement in accordance with its terms. Furthermore, termination of this Agreement by a party will be without prejudice to any other right or remedy of a party under this Agreement or applicable law.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 11 This section is about what we will do and what we won’t do as a part of our agreement.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      11.	Representations & Warranties and Disclaimers.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      11.1. 	Reps and Warranties. Each party represents and warrants that it has the legal power and authority to enter into this Agreement. You warrant that you are the minimum age required to enter into a contract in the area in which you reside, and in any event, not less than 18 years of age. FullStory warrants that it will provide the Services in a manner consistent with general industry standards reasonably applicable to the provision of such Services and that the Services will perform substantially in accordance with the User Guide under normal use and circumstances. Customer’s sole and exclusive remedy and FullStory’s sole obligation for a breach of the warranties in this Section, will be the correction or re-performance of the nonconforming Service by FullStory. If after reasonable efforts, neither remedy is commercially available, FullStory may cancel this Agreement and refund Customer, a pro-rata portion of the Fees that have been paid but not used by Customer from the date of notice by Customer of such breach.  Customer warrants that (i) Customer owns or has a license to use and has obtained all consents and approvals necessary for the provision and use of all of the Customer Data that is placed on, transmitted via or recorded by the Services; (ii) the provision and use of Customer Data as contemplated by this Agreement and the Services does not and will not violate any Customer privacy policy, terms-of-use or other agreement to which Customer is a party or any law or regulation to which Customer is subject.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      11.2. 	DISCLAIMER. FULLSTORY DOES NOT WARRANT THAT ACCESS TO THE SERVICES WILL BE UNINTERRUPTED OR ERROR FREE, NOR DOES FULLSTORY MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED OR THE LOSSES THAT MAY OCCUR FROM USE OF THE SERVICES. EXCEPT AS SPECIFICALLY SET FORTH IN THE AGREEMENT, THE SERVICES ARE PROVIDED “AS IS,” AND FULLSTORY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 12 This section covers that fancy word lawyers are always disagreeing over: indemnification. Basically, if you make a mess it is yours to clean up.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      12.	Indemnification.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      12.1. 	Customer’s Indemnification of FullStory. Customer will indemnify, defend and hold harmless FullStory and its respective directors, officers, employees and agents from and against any and all claims, losses, damages, suits, fees, judgments, costs and expenses, (including reasonable attorney’s fees) (“Claims”) or any claims by you or any third party which may arise from or relate to this Agreement or the provision of our service to you, including any damages caused by your use of our Site or acceptance of the offers contained on our Site.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      12.2. 	Procedure for Handling Indemnification Claims. In the event of any Claim, FullStory will give prompt notice of any such Claim to Customer; provided that the failure to provide such notice will not relieve Customer of its obligations unless such failure prejudices Customer’s ability to defend the Claim). Customer will be entitled if it so elects in a notice promptly delivered to FullStory, to immediately take control of the defense, settlement and investigation of any Claim and to employ and engage attorneys reasonably acceptable to FullStory to handle and defend the same, at Customer’s sole cost. FullStory will cooperate in all reasonable respects, at Customer’s cost and request, in the investigation, trial and defense of such Claim and any related appeals. Customer will not consent to the entry of any judgment or enter into any settlement with respect to a Claim without FullStory’s prior written consent, which may be withheld in its sole discretion. FullStory may also, at its own cost, participate through its attorneys or otherwise in such investigation, trial and defense of any Claim and related appeals.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      12.3. 	CUSTOMER (ON ITS OWN BEHALF AND ON BEHALF OF ANY PERSON OR ENTITY AUTHORIZED TO USE THE SERVICES BY CUSTOMER) COVENANTS NOT TO SUE OR MAKE OR ASSERT AGAINST FULLSTORY ANY CLAIM OF INFRINGEMENT OF ANY INTELLECTUAL PROPERTY RIGHT WITH RESPECT TO THE SERVICES PROVIDED BY FULLSTORY UNDER THIS AGREEMENT.    ')))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 13 This section proves that everyone has a limit. Here is ours.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    13.  	Limitation of Liability.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    YOU AGREE THAT FULLSTORY’S LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT, NO MATTER THE THEORY OF LIABILITY, WILL NOT EXCEED IN THE AGGREGATE THE TOTAL FEES PAID OR OWED BY CUSTOMER UNDER THIS AGREEMENT DURING THE THEN-CURRENT ORDER OR, IF LESS, THE 12 MONTHS IMMEDIATELY PRECEDING THE DATE OF THE EVENT GIVING RISE TO THE CLAIM.  YOU AGREE THAT WE ARE NOT RESPONSIBLE IN ANY WAY FOR DAMAGES CAUSED BY THIRD PARTIES WHO MAY USE OUR SERVICES, INCLUDING BUT NOT LIMITED TO PEOPLE WHO COMMIT INTELLECTUAL PROPERTY INFRINGEMENT, DEFAMATION, TORTIOUS INTERFERENCE WITH ECONOMIC RELATIONS, OR ANY OTHER ACTIONABLE CONDUCT TOWARDS YOU. WE ARE NOT RESPONSIBLE FOR ANY LOSSES INCURRED AS THE RESULT OF YOUR DECISION TO USE OUR SERVICE. YOU ARE RESPONSIBILITY FOR DETERMINING THE SUITABILITY OF OUR SERVICE FOR YOUR PURPOSES.  WE ARE NOT RESPONSIBLE FOR ANY FAILURE ON THE PART OF A PAYMENT PROCESSOR, INCLUDING YOUR CREDIT CARD COMPANY, TO DIRECT PAYMENTS TO THE CORRECT DESTINATION, OR ANY ACTIONS ON THEIR PART IN PLACING A HOLD ON YOUR FUNDS.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    WE ARE NOT LIABLE FOR ANY FAILURE OF THE GOODS OR SERVICES OF OUR COMPANY OR A THIRD PARTY, INCLUDING ANY FAILURES OR DISRUPTIONS, UNTIMELY DELIVERY, SCHEDULED OR UNSCHEDULED, INTENTIONAL OR UNINTENTIONAL, ON OUR WEBSITE WHICH PREVENT ACCESS TO OUR WEBSITE TEMPORARILY OR PERMANENTLY. THE PROVISION OF OUR SERVICE TO YOU IS CONTINGENT ON YOUR AGREEMENT WITH THIS AND ALL OTHER SECTIONS OF THIS AGREEMENT.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    THE PARTIES AGREE THAT IN NO EVENT WILL EITHER PARTY HAVE ANY LIABILITY TO THE OTHER PARTY FOR ANY LOST PROFITS OR REVENUES OR FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, COVER, SPECIAL, EXEMPLARY OR PUNITIVE DAMAGES, NO MATTER HOW CAUSED OR THE THEORY OF LIABILITY, AND WHETHER OR NOT A PARTY HAS BEEN ADVISED THAT SUCH DAMAGES ARE POSSIBLE.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    For Jurisdictions that do not allow us to limit our liability: Notwithstanding any provision of these Terms, if your jurisdiction has provisions specific to waiver or liability that conflict with the above then our liability is limited to the smallest extent possible by law. Specifically, in those jurisdictions not allowed, we do not disclaim liability for: (a) death or personal injury caused by its negligence or that of any of its officers, employees or agents; or (b) fraudulent misrepresentation; or (c) any liability which it is not lawful to exclude either now or in the future.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    IF YOU ARE A RESIDENT OF A JURISDICTION THAT REQUIRES A SPECIFIC STATEMENT REGARDING RELEASE THEN THE FOLLOWING APPLIES. FOR EXAMPLE, CALIFORNIA RESIDENTS MUST, AS A CONDITION OF THIS AGREEMENT, WAIVE THE APPLICABILITY OF CALIFORNIA CIVIL CODE SECTION 1542, WHICH STATES, “A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR." YOU HEREBY WAIVE THIS SECTION OF THE CALIFORNIA CIVIL CODE. YOU HEREBY WAIVE ANY SIMILAR PROVISION IN LAW, REGULATION, OR CODE THAT HAS THE SAME INTENT OR EFFECT AS THE ABOVE RELEASE.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 14 This section is for Government entities, ‘cause they are special. Are you one of those? If so, please read this part.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    14.	Special Terms for Government Customers.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    If Customer is a U.S. government entity, Customer agrees that the FullStory Products and any documentation provided by FullStory are deemed to be “commercial computer software” and “commercial computer software documentation” pursuant to Defense Federal Acquisition Regulation Supplement, codified under Chapter 2 of Title 48, United States Code of Federal Regulations, Section 227.7202, and Federal Acquisition Regulation, codified in Title 48 of the United States Code of Federal Regulations, Section 12.12. Any use, modification, reproduction, release, performance, display, or disclosure of the FullStory Products or documentation by the United States Government is governed solely by this Agreement and is prohibited except to the extent expressly permitted by this Agreement.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 15 This section is about dispute resolution. If the need arises, we plan to be reasonable and hope you will be, too. If not, we might see you down in Atlanta.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    15.	Forum of Dispute.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    You agree that any dispute arising from or relating to this Agreement will be heard solely by a court of competent jurisdiction in the State of Georgia. Specifically, where the subject matter of a dispute is eligible for it, you agree that any disputes will be heard solely within the lowest court of competent jurisdiction in the State of Georgia (Small Claims Court). If a dispute claims multiple claims and one or more of those claims would be eligible to be heard by the Small Claims Court, you agree not to bring the other claims against us and to instead proceed within the Small Claims Court. If you would be entitled in a dispute to an amount exceeding the monetary jurisdiction of the Small Claims Court, you agree to waive your right to collect any damages in excess of the monetary jurisdiction and instead still bring your claim within the Small Claims Court. You agree that if a dispute is eligible to be heard in Small Claims Court but you would be entitled to an additional or alternative remedy in a higher court, such as injunctive relief, you will waive your right to that remedy and still bring the dispute within the Small Claims Court. If you bring a dispute in a manner other than in accordance with this section, you agree that we may move to have it dismissed, and that you will be responsible for our reasonable attorneys’ fees, court costs, and disbursements in doing so. You agree that the unsuccessful party in any dispute arising from or relating to this Agreement will be responsible for the reimbursement of the successful party’s reasonable attorneys’ fees, court costs, and disbursements.  If you conduct a chargeback rather than using our Forum of Dispute procedure described above, FullStory will be entitled to recover the full amount of the chargeback, as well as any of its fees, disbursements, or other costs or expenses involved in recovering that amount.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 16 This section is our mailing address. If you’ve got an important thing to say, please be sure we get the message in writing at the below address.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    16.	Notices.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Any notice under this Agreement must be given in writing. FullStory may provide notice to you via email or through your account. FullStory’s notices to you will be deemed given upon the first business day after we send it. You may provide notice to us by post to FullStory, Inc., 1745 Peachtree St NW, Suite G, Atlanta, GA 30309 USA, Attn: Legal. Your notices to us will be deemed given upon our receipt.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText header').appendText('    17.	Assignment.  '))
      .append(createOne('p', doc).setAttr('class', 'tacText').appendText('    Customer agrees that it will not assign this Agreement without the prior written consent of FullStory.  FullStory may assign our rights and obligations under this Agreement (in whole or in part) without your consent. Any attempted assignment in violation of this Section will be void.  '))
      .append(createOne('p', doc).setAttr('class', 'tacTextHuman').appendText('    Section 18 This section is a bunch of legal words that are pretty standard but according to our legal team must be said.  '))
      .append(createOne('ul', doc).setAttr('class', 'tacList')
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem  header').appendText('      18.	Miscellaneous.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.1. 	Publicity.  We may identify you as an FullStory customer in our promotional materials. You may request that we stop doing so by submitting an email to hugs@fullstory.com at any time. Please note that it may take us up to 14 days to process your request.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.2. 	No Third Party Beneficiaries. This Agreement will be binding upon and inure solely to the benefit of the parties. The parties intend that there will be no third party beneficiaries under this Agreement, and that no person or entity, except the parties, will have any rights or remedies under this Agreement, including the right to bring any action on account of its breach or in any relation to it whether in contract, in tort, or otherwise.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.3. 	Compliance with Laws. Customer agrees that it will comply with all laws, administrative regulations and executive orders relating to the control of imports and exports of commodities and technical data, use or remote use of software and related property, or registration of this Agreement that may apply in the United States or in any other jurisdiction in which the Services will be located or from which the Services will be accessed under this Agreement, including, but not limited to, the Export Administration Regulations of the U.S. Department of Commerce, the International Traffic in Arms Regulations of the U.S. Department of State, and the Enhanced Proliferation Control Initiative. Customer will not, without prior written consent, if required, of the office of Export Administration of the U.S. Department of Commerce, or other applicable U.S. governmental agency or department, export, re-export, allow the re-export, transship, download, or transmit any part of the Services or Confidential Information to any country (“Restricted Nation”), person or entity to which such transmission is restricted by applicable regulations or statutes, including to any individual, group or organization on the U.S. Department of Treasury\'s Office of Foreign Assets Control\'s list of Specially Designated Nationals or the U.S. Department of Commerce\'s Bureau of Export Administration\'s List of Denied Persons, as each may be amended from time to time.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.4. 	Relationship. The relationship between the parties created by this Agreement is that of independent contractors and not partners, joint venturers or agents. Except as expressly agreed by the parties, neither party will be deemed to be an employee, agent, partner or legal representative of the other for any purpose and neither will have any right, power or authority to create any obligation or responsibility on behalf of the other.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.5.	 No Exclusivity.  Nothing in this Agreement restricts a party\'s right to contract with any third party to provide products and/or services similar to or identical to the Services provided under this Agreement.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.6. 	Entire Agreement. This Agreement, the applicable Order and the attachments and schedules attached to this Agreement constitute the entire Agreement of the parties with respect to the subject matter hereof and supersedes any and all existing agreements relating to the subject matter hereof. To the extent, there is any conflict among the terms of this Agreement and the applicable Order, such conflict will be governed in the following order: 1) the terms of the Order; and then, 2) this Agreement and any applicable addenda, the terms of which are incorporated into the Order by reference.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.7. 	Modification and Waiver. No modification of this Agreement, and no waiver of any breach of this Agreement, will be effective unless in writing and signed by an authorized representative of the party against whom enforcement is sought. No waiver of any breach of this Agreement, and no course of dealing between the parties, will be construed as a waiver of any subsequent breach of this Agreement.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.8. 	Force Majeure. Neither party will be liable for any failure or delay in the performance of any of their respective obligations (other than confidentiality obligations and payment obligations) if prevented from doing so by a cause or causes beyond its reasonable control (a “Force Majeure Event”). Without limiting the generality of the foregoing, Force Majeure Events include fires, floods, terrorism, strikes, blackouts, war, restraints of government, utility or communications failures or interruptions, failures of third party vendors, Internet slow-downs or failures, computer hackers or other causes that are beyond a party’s reasonable control. Failure to meet due dates or time schedules resulting from a Force Majeure Event will extend the due dates or time schedules for reasonable periods of time as determined by the parties in good faith.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.9. 	Severability. The illegality, invalidity, or unenforceability of any provision of this Agreement will not in any manner affect or render illegal, invalid or unenforceable any other provision of this Agreement, and that provision, and this Agreement generally, will be reformed, construed and enforced so as to most nearly give lawful effect to the intent of the parties as expressed in this Agreement.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.10. 	Headings. Section headings are for convenience of reference only and will not affect the interpretation of this Agreement.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.11. 	Counterparts. This Agreement may be executed in counterparts, each of which will be deemed an original, but which together will constitute one and the same instrument. Electronic execution and delivery of this Agreement is legal, valid and binding execution and delivery for all purposes.    '))
        .append(createOne('li', doc).setAttr('class', 'tacText tacListItem ').appendText('      18.12. 	Governing Law. This Agreement, and all matters arising directly or indirectly from this Agreement, will be governed by and construed in accordance with the laws of the State of Georgia, without regard to its conflict of laws rules applicable to contracts to be performed entirely within the State of Georgia, and without regard to the U.N. Convention on the International Sale of Goods.    ')));
  }
}



export class TestDriveAppView extends OfOne {
  trialButton: OfOne;
  container: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'TestDriveAppView')
      .append(createOne('div', doc).setAttr('class', 'header')
        .append(createOne('a', doc).setAttr('href', '/').setAttr('target', '_blank').setAttr('class', 'logo'))
        .append(this.trialButton = createOne('button', doc).appendText('Start your free 14-day trial'))
        .append(createOne('a', doc).setAttr('href', 'https://help.fullstory.com/').setAttr('target', '_blank').setAttr('class', 'learnMore').appendText('Learn More')))
      .append(this.container = createOne('div', doc).setAttr('class', 'container'));
  }
}



export class TestDriveIntroView extends OfOne {
  mouseMoveTarget: OfOne;
  play: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'TestDriveIntro')
      .append(this.mouseMoveTarget = createOne('div', doc).setAttr('class', 'mouseMoveTarget'))
      .append(this.play = createOne('div', doc).setAttr('class', 'play'));
  }
}



export class DailyActivesThresholdConfigView extends OfOne {
  frequency: OfOne;
  modifier: OfOne;
  value: OfOne;
  subtext: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DailyActivesThresholdConfig')
      .append(createOne('span', doc).setAttr('class', 'bold')
        .append(this.frequency = createOne('span', doc)).appendText(' active')).appendText(' users is  ')
      .append(this.modifier = createOne('button', doc).setAttr('class', 'modifier'))
      .append(this.value = createOne('div', doc).setAttr('contenteditable', 'true').setAttr('spellcheck', 'false').setAttr('class', 'value'))
      .append(createOne('div', doc).setAttr('class', 'explanation')
        .append(this.subtext = createOne('span', doc))
        .append(createOne('span', doc).appendText(' ')
          .append(createOne('a', doc).setAttr('href', 'https://help.fullstory.com/hc/en-us/articles/360020828653').setAttr('target', '_blank').appendText('Learn more'))));
  }
}



export class DailyActivesThresholdExplanationView extends OfOne {
  freq: OfOne;
  direction: OfOne;
  value: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DailyActivesThresholdExplanation')
      .append(createOne('div', doc).setAttr('class', 'icon'))
      .append(createOne('span', doc)
        .append(this.freq = createOne('span', doc)).appendText(' active users ')
        .append(this.direction = createOne('span', doc)).appendText(' ')
        .append(this.value = createOne('span', doc)));
  }
}



export class ExportItemView extends OfOne {
  exportId: OfOne;
  dateRange: OfOne;
  statusContainer: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ExportItem')
      .append(this.exportId = createOne('div', doc).setAttr('class', 'col small'))
      .append(this.dateRange = createOne('div', doc).setAttr('class', 'col medium'))
      .append(createOne('div', doc).setAttr('class', 'col small pushRight')
        .append(this.statusContainer = createOne('div', doc).setAttr('class', 'status')));
  }
}



export class ExportsView extends OfOne {
  gridLabels: OfOne;
  exportsContainer: OfOne;
  noResults: OfOne;
  exportList: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'Exports')
      .append(createOne('div', doc).setAttr('class', 'header').appendText('Available Data Bundles'))
      .append(createOne('div', doc).setAttr('id', 'ExportList').setAttr('class', 'ExportListView gridContainer')
        .append(this.gridLabels = createOne('div', doc).setAttr('class', 'gridLabels')
          .append(createOne('div', doc).setAttr('class', 'grid')
            .append(createOne('div', doc).setAttr('class', 'col small').appendText('export id'))
            .append(createOne('div', doc).setAttr('class', 'col medium').appendText('date range'))
            .append(createOne('div', doc).setAttr('class', 'col small pushRight').appendText('status'))))
        .append(this.exportsContainer = createOne('div', doc).setAttr('class', 'gridContents')
          .append(this.noResults = createOne('div', doc).setAttr('class', 'noResults').appendText('There are no pending or completed data bundles available for export.'))
          .append(this.exportList = createOne('div', doc).setAttr('class', 'itemList'))));
  }
}



export class SendNoteView extends OfOne {
  close: OfOne;
  title: OfOne;
  subTitle: OfOne;
  intgConfig: OfOne;
  intgConfigDisplay: OfOne;
  intgConfigEdit: OfOne;
  intgFields: OfOne;
  errMsg: OfOne;
  fields: OfOne;
  reportBugFields: OfOne;
  fieldHeader: OfOne;
  metadataText: OfOne;
  copyBox: OfOne;
  copyIcon: OfOne;
  copyText: OfOne;
  genericFooter: OfOne;
  genericFooterErrorTxt: OfOne;
  send: OfOne;
  reportBugFooter: OfOne;
  intgHeaderTxt: OfOne;
  seeAll: OfOne;
  logoRow: OfOne;
  intgJira: OfOne;
  intgTrello: OfOne;
  intgSlack: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'sendNoteContainer')
      .append(createOne('div', doc).setAttr('class', 'sendNotePanel')
        .append(createOne('div', doc).setAttr('class', 'close')
          .append(this.close = createOne('img', doc).setAttr('src', '/s/img/close.svg').setAttr('class', 'xToClose')))
        .append(this.title = createOne('div', doc).setAttr('class', 'panelHeader')
          .append(this.subTitle = createOne('div', doc).setAttr('class', 'subtitle')))
        .append(this.intgConfig = createOne('div', doc).setAttr('class', 'panelConfig hidden')
          .append(this.intgConfigDisplay = createOne('div', doc).setAttr('class', 'configDisplayFields'))
          .append(this.intgConfigEdit = createOne('div', doc).setAttr('class', 'configEditFields')))
        .append(this.intgFields = createOne('div', doc).setAttr('class', 'panelContent')
          .append(this.errMsg = createOne('div', doc).setAttr('class', 'error errorSpecific'))
          .append(this.fields = createOne('div', doc)))
        .append(this.reportBugFields = createOne('div', doc).setAttr('class', 'panelContent')
          .append(createOne('div', doc).setAttr('class', 'fieldContainer')
            .append(this.fieldHeader = createOne('label', doc))
            .append(this.metadataText = createOne('textarea', doc))
            .append(this.copyBox = createOne('div', doc).setAttr('class', 'copyBox')
              .append(this.copyIcon = createOne('div', doc).setAttr('class', 'copy').setAttr('title', 'Copy link'))
              .append(this.copyText = createOne('span', doc)))))
        .append(this.genericFooter = createOne('div', doc).setAttr('class', 'panelFooter')
          .append(this.genericFooterErrorTxt = createOne('div', doc).setAttr('class', 'error'))
          .append(this.send = createOne('button', doc).setAttr('class', 'saveBtn')))
        .append(this.reportBugFooter = createOne('div', doc).setAttr('class', 'reportBugFooter')
          .append(createOne('div', doc)
            .append(this.intgHeaderTxt = createOne('label', doc))
            .append(this.seeAll = createOne('span', doc).setAttr('class', 'btnLink')))
          .append(this.logoRow = createOne('div', doc).setAttr('class', 'logoRow')
            .append(this.intgJira = createOne('div', doc).setAttr('class', 'logoContainer')
              .append(createOne('div', doc).setAttr('class', 'logoBox')
                .append(createOne('img', doc).setAttr('src', '/s/img/thirdparty/Jira_Software-blue.svg'))))
            .append(this.intgTrello = createOne('div', doc).setAttr('class', 'logoContainer')
              .append(createOne('div', doc).setAttr('class', 'logoBox')
                .append(createOne('img', doc).setAttr('src', '/s/img/thirdparty/trello-logo-blue.svg'))))
            .append(this.intgSlack = createOne('div', doc).setAttr('class', 'logoContainer')
              .append(createOne('div', doc).setAttr('class', 'logoBox')
                .append(createOne('img', doc).setAttr('style', 'max-height: 120%').setAttr('src', '/s/img/thirdparty/Slack_RGB.svg')))))));
  }
}



export class DataPillView extends OfOne {
  title: OfOne;
  data: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DataPill')
      .append(this.title = createOne('div', doc).setAttr('class', 'title'))
      .append(this.data = createOne('div', doc).setAttr('class', 'data'));
  }
}



export class FillerListItemsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'fillerListItem')
      .append(createOne('div', doc).setAttr('class', 'fillVatar'))
      .append(createOne('div', doc).setAttr('class', 'fill1')
        .append(createOne('div', doc).setAttr('class', 'blockGray small'))
        .append(createOne('div', doc).setAttr('class', 'blockGray short small')))
      .append(createOne('div', doc).setAttr('class', 'fill2')
        .append(createOne('div', doc).setAttr('class', 'fakePlayButton'))
        .append(createOne('div', doc).setAttr('class', 'blockGray medium'))
        .append(createOne('div', doc).setAttr('class', 'blockGray short large')))
      .append(createOne('div', doc).setAttr('class', 'fill3')
        .append(createOne('div', doc).setAttr('class', 'blockGray small right'))
        .append(createOne('div', doc).setAttr('class', 'blockGray short large right')));
  }
}



export class OrgChooserItemView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('id', '').setAttr('class', 'al-item');
  }
}



export class SessionItemView extends OfOne {
  autoplay: OfOne;
  session: OfOne;
  pages: OfOne;
  events: OfOne;
  length: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SessionItem')
      .append(this.autoplay = createOne('div', doc).setAttr('class', 'quickplay'))
      .append(this.session = createOne('div', doc).setAttr('class', 'col large session'))
      .append(this.pages = createOne('div', doc).setAttr('class', 'col pages'))
      .append(this.events = createOne('div', doc).setAttr('class', 'col events'))
      .append(this.length = createOne('div', doc).setAttr('class', 'col length pushRight'));
  }
}



export class MetricsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('id', 'metricsContainer');
  }
}



export class PageView extends OfOne {
  topN: OfOne;
  screenshot: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'page')
      .append(this.topN = createOne('div', doc).setAttr('class', 'topN'))
      .append(this.screenshot = createOne('iframe', doc));
  }
}



export class PagebrowserView extends OfOne {
  search: OfOne;
  showOutliers: OfOne;
  title: OfOne;
  pages: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(this.search = createOne('input', doc).setAttr('type', 'text'))
      .append(this.showOutliers = createOne('input', doc).setAttr('type', 'checkbox'))
      .append(this.title = createOne('h3', doc))
      .append(this.pages = createOne('div', doc).setAttr('class', 'pages'));
  }
}



export class PersonaCellView extends OfOne {
  img: OfOne;
  title: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'PersonaCell')
      .append(this.img = createOne('div', doc).setAttr('class', 'iconPersona'))
      .append(this.title = createOne('p', doc).setAttr('class', 'cellText'))
      .append(createOne('div', doc).setAttr('class', 'cellLabel'));
  }
}



export class DropdownContainerView extends OfOne {
  selection: OfOne;
  selectedState: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DropdownContainer').setAttr('id', 'dropdown').setAttr('tabindex', '0')
      .append(this.selection = createOne('div', doc).setAttr('class', 'selection')
        .append(createOne('div', doc).setAttr('id', 'ellipsis')
          .append(this.selectedState = createOne('div', doc).setAttr('id', 'selectedState')))
        .append(createOne('div', doc).setAttr('class', 'arrow')));
  }
}



export class OptionsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DropdownOptions');
  }
}



export class AddSearchView extends OfOne {
  addToSearch: OfOne;
  newSearch: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(this.addToSearch = createOne('div', doc)
        .append(createOne('a', doc).appendText('Add to Search')))
      .append(this.newSearch = createOne('div', doc)
        .append(createOne('a', doc).appendText('Create new Search')));
  }
}



export class AutoplayView extends OfOne {
  autoplayToggle: OfOne;
  toggleOnTxt: OfOne;
  toggleOffTxt: OfOne;
  autoplaySourceValue: OfOne;
  timeUntilNextCountdown: OfOne;
  timeUntilNextTxt: OfOne;
  countdown: OfOne;
  pagination: LeftRightPaginationView;
  embedRedirectToFSTA: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'AutoplayView')
      .append(createOne('div', doc).setAttr('class', 'container')
        .append(createOne('div', doc).setAttr('class', 'left')
          .append(createOne('div', doc).setAttr('class', 'toggleText')
            .append(this.autoplayToggle = createOne('span', doc).setAttr('class', 'togTextAction is-on')
              .append(this.toggleOnTxt = createOne('span', doc).setAttr('class', 'textOn'))
              .append(this.toggleOffTxt = createOne('span', doc).setAttr('class', 'textOff')))
            .append(createOne('span', doc).setAttr('class', 'togTextTuning')
              .append(this.autoplaySourceValue = createOne('span', doc).setAttr('class', 'togTextSupporting'))))
          .append(createOne('span', doc).setAttr('class', 'timeUntilNext')
            .append(this.timeUntilNextCountdown = createOne('span', doc).setAttr('style', 'display:none').appendText(' ')
              .append(this.timeUntilNextTxt = createOne('span', doc)).appendText(' ')
              .append(this.countdown = createOne('span', doc).appendText('5')))))
        .append(createOne('div', doc).setAttr('class', 'right')
          .append(this.pagination = <LeftRightPaginationView>new LeftRightPaginationView(doc)))
        .append(this.embedRedirectToFSTA = createOne('a', doc).setAttr('class', 'embedRedirectToFSTA hidden').setAttr('target', '_blank').setAttr('rel', 'noreferrer')));
  }
}



export class BlankPlaybackView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'BlankPlayback').appendText('There was an error loading the page.');
  }
}



export class EventContainerView extends OfOne {
  referrer: OfOne;
  reflink: OfOne;
  sessionInfo: OfOne;
  calDigit: OfOne;
  date: OfOne;
  summary: OfOne;
  events: OfOne;
  playOn: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'EventContainer')
      .append(createOne('div', doc).setAttr('class', 'inside')
        .append(this.referrer = createOne('div', doc).setAttr('class', 'referrer').appendText('referred by: ')
          .append(this.reflink = createOne('a', doc).setAttr('target', '_blank').setAttr('href', '#')))
        .append(this.sessionInfo = createOne('div', doc).setAttr('class', 'sessionInfo noBg')
          .append(createOne('div', doc).setAttr('class', 'cal')
            .append(this.calDigit = createOne('div', doc).setAttr('class', 'digit')))
          .append(createOne('div', doc).setAttr('class', 'originalSessionLink')
            .append(this.date = createOne('a', doc).setAttr('class', 'date').setAttr('title', 'View entire Session'))
            .append(this.summary = createOne('div', doc).setAttr('class', 'summary').appendText('WATCH THE FULL SESSION →'))))
        .append(this.events = createOne('div', doc).setAttr('class', 'events'))
        .append(this.playOn = createOne('div', doc).setAttr('class', 'playOn sessionInfo noBg').appendText('play on')));
  }
}



export class EventItemView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'eventItem');
  }
}



export class EventListNativeInfoView extends OfOne {
  version: OfOne;
  buildTypeRow: OfOne;
  buildType: OfOne;
  packageNameLabel: OfOne;
  packageName: OfOne;
  fsSDKVersion: OfOne;
  fsBuildId: OfOne;
  deviceModel: OfOne;
  manufacturer: OfOne;
  osVersion: OfOne;
  product: OfOne;
  display: OfOne;
  resolution: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'EventListNativeInfo')
      .append(createOne('div', doc).setAttr('class', 'fullInfoHeading').appendText('App'))
      .append(createOne('hr', doc))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Version:'))
        .append(this.version = createOne('div', doc).setAttr('id', 'version').setAttr('class', 'value')))
      .append(this.buildTypeRow = createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Build Type:'))
        .append(this.buildType = createOne('div', doc).setAttr('id', 'buildType').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(this.packageNameLabel = createOne('div', doc).setAttr('class', 'label').appendText('Package Name:'))
        .append(this.packageName = createOne('div', doc).setAttr('id', 'packageName').setAttr('class', 'value rtl')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('FS SDK Version:'))
        .append(this.fsSDKVersion = createOne('div', doc).setAttr('id', 'fsSDKVersion').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('FS Build ID:'))
        .append(this.fsBuildId = createOne('div', doc).setAttr('id', 'fsBuildId').setAttr('class', 'value rtl')))
      .append(createOne('div', doc).setAttr('class', 'fullInfoHeading').appendText('Device'))
      .append(createOne('hr', doc))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Device Model:'))
        .append(this.deviceModel = createOne('div', doc).setAttr('id', 'deviceModel').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Manufacturer:'))
        .append(this.manufacturer = createOne('div', doc).setAttr('id', 'manufacturer').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('OS Version:'))
        .append(this.osVersion = createOne('div', doc).setAttr('id', 'osVersion').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Product:'))
        .append(this.product = createOne('div', doc).setAttr('id', 'product').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Display:'))
        .append(this.display = createOne('div', doc).setAttr('id', 'display').setAttr('class', 'value')))
      .append(createOne('div', doc).setAttr('class', 'row')
        .append(createOne('div', doc).setAttr('class', 'label').appendText('Resolution:'))
        .append(this.resolution = createOne('div', doc).setAttr('id', 'resolution').setAttr('class', 'value')));
  }
}



export class EventTimeView extends OfOne {
  timeAmPm: OfOne;
  time24: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'eventTime')
      .append(this.timeAmPm = createOne('span', doc).setAttr('class', 'timeAmPm'))
      .append(this.time24 = createOne('span', doc).setAttr('class', 'time24'));
  }
}



export class LoadEventView extends OfOne {
  trigger: OfOne;
  visitUrl: OfOne;
  pageLoadVal: OfOne;
  progressBars: OfOne;
  metricsSubview: OfOne;
  verticalBar: OfOne;
  metricRows: OfOne;
  downloadHAR: OfOne;
  loadTime: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'loadEventContainer')
      .append(this.trigger = createOne('div', doc).setAttr('class', 'loadEvent')
        .append(createOne('div', doc).setAttr('class', 'headerrow descriptors')
          .append(createOne('div', doc).setAttr('class', 'description')
            .append(createOne('div', doc).setAttr('class', 'icon')))
          .append(createOne('div', doc).appendText('                PAGE LOAD            ')))
        .append(createOne('div', doc).setAttr('class', 'headerrow details')
          .append(this.visitUrl = createOne('div', doc).setAttr('class', 'visitUrl'))
          .append(this.pageLoadVal = createOne('div', doc)))
        .append(this.progressBars = createOne('div', doc).setAttr('class', 'progressBars')))
      .append(createOne('div', doc).setAttr('class', 'subviewContainer').setAttr('title', '')
        .append(this.metricsSubview = createOne('div', doc).setAttr('class', 'loadEventSubview collapsed')
          .append(this.verticalBar = createOne('div', doc).setAttr('class', 'verticalbar'))
          .append(this.metricRows = createOne('div', doc))
          .append(createOne('div', doc).setAttr('class', 'row footer')
            .append(createOne('div', doc).setAttr('class', 'split')
              .append(this.downloadHAR = createOne('button', doc).setAttr('class', 'downloadHAR')
                .append(createOne('div', doc).setAttr('class', 'icon')).appendText('                        Download HAR                    '))
              .append(this.loadTime = createOne('span', doc).setAttr('class', 'loadTimestamp'))))));
  }
}



export class LoadEventRowView extends OfOne {
  row: OfOne;
  circle: OfOne;
  title: OfOne;
  measurement: OfOne;
  search: AddSearchView;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'LoadEventRow')
      .append(this.row = createOne('div', doc).setAttr('class', 'row lpad')
        .append(createOne('span', doc).setAttr('class', 'whitecircle')
          .append(this.circle = createOne('span', doc).setAttr('class', 'circle')))
        .append(createOne('div', doc).setAttr('class', 'split')
          .append(this.title = createOne('span', doc).setAttr('class', 'title'))
          .append(this.measurement = createOne('span', doc).setAttr('class', 'measurement'))))
      .append(createOne('div', doc)
        .append(this.search = <AddSearchView>new AddSearchView(doc).setAttr('class', 'hidden AddSearch')));
  }
}



export class NotePreviewView extends OfOne {
  close: OfOne;
  detailsLabel: OfOne;
  created: OfOne;
  avatar: OfOne;
  detailsCreatedByLabel: OfOne;
  creator: OfOne;
  textContent: OfOne;
  play: OfOne;
  playContainerTxt: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'NotePreview')
      .append(createOne('div', doc).setAttr('class', 'dialog')
        .append(this.close = createOne('div', doc).setAttr('class', 'close'))
        .append(createOne('div', doc).setAttr('class', 'top')
          .append(createOne('div', doc).setAttr('class', 'details')
            .append(this.detailsLabel = createOne('div', doc).setAttr('class', 'label'))
            .append(this.created = createOne('div', doc).setAttr('class', 'detail created')))
          .append(createOne('div', doc).setAttr('class', 'details')
            .append(this.avatar = createOne('div', doc).setAttr('class', 'avatar noGravatar')))
          .append(createOne('div', doc).setAttr('class', 'details')
            .append(this.detailsCreatedByLabel = createOne('div', doc).setAttr('class', 'label'))
            .append(this.creator = createOne('div', doc).setAttr('class', 'detail creator'))))
        .append(createOne('div', doc).setAttr('class', 'main')
          .append(createOne('div', doc).setAttr('class', 'content')
            .append(this.textContent = createOne('div', doc).setAttr('class', 'textContent')))
          .append(this.play = createOne('div', doc).setAttr('class', 'playContainer')
            .append(createOne('div', doc).setAttr('class', 'playIcon'))
            .append(this.playContainerTxt = createOne('div', doc).setAttr('class', 'playText')))));
  }
}



export class PagePlaybackView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('iframe'));

    this.setAttr('class', 'WebPagePlayback WebPagePlayback--preloading');
  }
}



export class PlaybackUrlInfoBarView extends OfOne {
  innerContainer: OfOne;
  urlText: OfOne;
  visitLink: OfOne;
  pageInsightsDisclaimer: OfOne;
  pageInsightsDisclaimerTxt: OfOne;
  pageInsightsLearnMore: OfOne;
  deviceType: OfOne;
  viewportWidth: OfOne;
  viewportHeight: OfOne;
  divider: OfOne;
  devtools: OfOne;
  toolMode: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'urlInfoBar')
      .append(this.innerContainer = createOne('div', doc).setAttr('class', 'innerContainer left')
        .append(createOne('div', doc).setAttr('class', 'barItem urlTextContainer')
          .append(this.urlText = createOne('input', doc).setAttr('type', 'text').setAttr('readonly', 'readonly').setAttr('class', 'barItem urlText'))
          .append(this.visitLink = createOne('a', doc).setAttr('class', 'visitLink').setAttr('target', '_blank').setAttr('data-purpose', 'playback visit external link'))
          .append(this.pageInsightsDisclaimer = createOne('div', doc).setAttr('class', 'pageInsightsDisclaimer')
            .append(this.pageInsightsDisclaimerTxt = createOne('span', doc))
            .append(this.pageInsightsLearnMore = createOne('a', doc).setAttr('href', 'https://help.fullstory.com/hc/en-us/articles/360020624074').setAttr('target', '_blank')))))
      .append(createOne('div', doc).setAttr('class', 'innerContainer right')
        .append(this.deviceType = createOne('div', doc).setAttr('class', 'barItem deviceType'))
        .append(createOne('div', doc).setAttr('class', 'viewportDimensions')
          .append(this.viewportWidth = createOne('span', doc)).appendText(' x ')
          .append(this.viewportHeight = createOne('span', doc)))
        .append(this.divider = createOne('span', doc).setAttr('class', 'barItem urlInfoBarDivider'))
        .append(this.devtools = createOne('div', doc).setAttr('class', 'btn console').setAttr('title', 'Toggle Devtools').setAttr('data-purpose', 'playback toggle devtools')
          .append(createOne('div', doc).setAttr('class', 'icon-console'))
          .append(this.toolMode = createOne('span', doc).setAttr('class', 'toolMode'))));
  }
}



export class RequestAccessView extends OfOne {
  textContainer: OfOne;
  heyText: OfOne;
  instructionText: OfOne;
  requestButton: OfOne;
  logout: OfOne;
  header: OfOne;
  copyTxt: OfOne;
  requestLink: OfOne;
  teaserSearchTxt: OfOne;
  learnMoreSearchLink: OfOne;
  teaserFindTxt: OfOne;
  learnMoreFindLink: OfOne;
  teaserPlayTxt: OfOne;
  learnMorePlayLink: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(createOne('div', doc).setAttr('class', 'requestAccessDialog width800')
        .append(createOne('div', doc).setAttr('class', 'col left text-center')
          .append(createOne('div', doc).setAttr('class', 'topGraph')
            .append(createOne('img', doc).setAttr('class', 'logo').setAttr('src', '/s/img/svg/fs-logo-white-135x39.svg')))
          .append(this.textContainer = createOne('div', doc).setAttr('class', 'textContainer')
            .append(this.heyText = createOne('div', doc).setAttr('class', 'heyText'))
            .append(this.instructionText = createOne('div', doc).setAttr('class', 'instructionText')))
          .append(this.requestButton = createOne('div', doc).setAttr('class', 'cta'))
          .append(this.logout = createOne('a', doc).setAttr('href', '/logout').setAttr('class', 'cta-logout')))
        .append(createOne('div', doc).setAttr('class', 'col right text-left')
          .append(this.header = createOne('h1', doc).setAttr('class', 'header'))
          .append(createOne('p', doc).setAttr('class', 'copy')
            .append(this.copyTxt = createOne('span', doc)).appendText(' ')
            .append(this.requestLink = createOne('a', doc).setAttr('href', '#')))
          .append(createOne('div', doc).setAttr('class', 'teaser')
            .append(createOne('div', doc).setAttr('class', 'image search'))
            .append(createOne('div', doc).setAttr('class', 'text')
              .append(this.teaserSearchTxt = createOne('span', doc)).appendText(' ')
              .append(this.learnMoreSearchLink = createOne('a', doc).setAttr('class', 'teaserLink').setAttr('href', '//www.fullstory.com/features'))))
          .append(createOne('div', doc).setAttr('class', 'teaser')
            .append(createOne('div', doc).setAttr('class', 'image rage'))
            .append(createOne('div', doc).setAttr('class', 'text')
              .append(this.teaserFindTxt = createOne('span', doc)).appendText(' ')
              .append(this.learnMoreFindLink = createOne('a', doc).setAttr('class', 'teaserLink').setAttr('href', '//www.fullstory.com/features'))))
          .append(createOne('div', doc).setAttr('class', 'teaser')
            .append(createOne('div', doc).setAttr('class', 'image console'))
            .append(createOne('div', doc).setAttr('class', 'text')
              .append(this.teaserPlayTxt = createOne('span', doc)).appendText(' ')
              .append(this.learnMorePlayLink = createOne('a', doc).setAttr('class', 'teaserLink').setAttr('href', '//www.fullstory.com/features'))))));
  }
}



export class SessionPlaybackView extends OfOne {
  sessionContentWrapper: OfOne;
  pageContainer: OfOne;
  urlInfoBar: OfOne;
  resourceErrorBox: OfOne;
  reWebMessage: OfOne;
  reWebMessageTxt: OfOne;
  reWebMessageLink: OfOne;
  reMobileMapMessage: OfOne;
  reMobileMapMessageTxt: OfOne;
  reMobileMapMessageLink: OfOne;
  reMobileInternalErrorMessage: OfOne;
  ignoreError: OfOne;
  aggregationMessageContainer: OfOne;
  playback: OfOne;
  badSessionDataError: OfOne;
  badSessionDataErrorTxt: OfOne;
  clientError: OfOne;
  clientErrorTxt: OfOne;
  internalError: OfOne;
  internalErrorTxt: OfOne;
  genericServerError: OfOne;
  genericServerErrorTxt: OfOne;
  retentionServerError: OfOne;
  retentionServerErrorTxt: OfOne;
  rendererOverlay: OfOne;
  golivebutton: OfOne;
  devTools: OfOne;
  timeline: TimelineView;
  sessionPlaybackSidebar: OfOne;
  autoplay: AutoplayView;
  eventListWrapper: OfOne;
  eventList: OfOne;
  tabs: OfOne;
  replayTab: OfOne;
  replayTabLabel: OfOne;
  insightsTab: OfOne;
  insightsTabLabel: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SessionPlaybackView')
      .append(this.sessionContentWrapper = createOne('div', doc).setAttr('class', 'sessionContentWrapper')
        .append(this.pageContainer = createOne('div', doc).setAttr('class', 'pageContainer')
          .append(this.urlInfoBar = createOne('div', doc))
          .append(this.resourceErrorBox = createOne('div', doc).setAttr('class', 'resourceErrorBox')
            .append(createOne('div', doc).setAttr('class', 'resourceError')
              .append(this.reWebMessage = createOne('span', doc).setAttr('class', 'reMessage')
                .append(this.reWebMessageTxt = createOne('span', doc)).appendText(' ')
                .append(this.reWebMessageLink = createOne('a', doc).setAttr('href', 'https://help.fullstory.com/hc/en-us/articles/360020624494').setAttr('target', '_blank').setAttr('class', 'reLink')))
              .append(this.reMobileMapMessage = createOne('span', doc).setAttr('class', 'reMessage')
                .append(this.reMobileMapMessageTxt = createOne('span', doc)).appendText(' ')
                .append(this.reMobileMapMessageLink = createOne('a', doc).setAttr('href', 'https://help.fullstory.com/hc/en-us/articles/4414642861463-Intro-to-FullStory-for-Mobile-Apps').setAttr('target', '_blank').setAttr('class', 'reLink')))
              .append(this.reMobileInternalErrorMessage = createOne('span', doc).setAttr('class', 'reMessage'))
              .append(this.ignoreError = createOne('div', doc).setAttr('class', 'reClose'))))
          .append(this.aggregationMessageContainer = createOne('div', doc).setAttr('class', 'aggregationMessageContainer'))
          .append(createOne('div', doc).setAttr('class', 'playbackRendererContainer')
            .append(this.playback = createOne('div', doc).setAttr('class', 'PagePlayback'))
            .append(this.badSessionDataError = createOne('div', doc).setAttr('data-component', 'badSessionDataError').setAttr('class', 'errorOverlay')
              .append(createOne('div', doc).setAttr('class', 'errorOverlayIcon'))
              .append(this.badSessionDataErrorTxt = createOne('span', doc)))
            .append(this.clientError = createOne('div', doc).setAttr('data-component', 'clientError').setAttr('class', 'errorOverlay')
              .append(createOne('div', doc).setAttr('class', 'errorOverlayIcon'))
              .append(this.clientErrorTxt = createOne('span', doc)))
            .append(this.internalError = createOne('div', doc).setAttr('data-component', 'internalError').setAttr('class', 'errorOverlay')
              .append(createOne('div', doc).setAttr('class', 'errorOverlayIcon'))
              .append(this.internalErrorTxt = createOne('span', doc)))
            .append(this.genericServerError = createOne('div', doc).setAttr('data-component', 'genericServerError').setAttr('class', 'errorOverlay')
              .append(createOne('div', doc).setAttr('class', 'errorOverlayIcon'))
              .append(this.genericServerErrorTxt = createOne('span', doc)))
            .append(this.retentionServerError = createOne('div', doc).setAttr('data-component', 'retentionServerError').setAttr('class', 'errorOverlay')
              .append(createOne('div', doc).setAttr('class', 'errorOverlayIcon'))
              .append(this.retentionServerErrorTxt = createOne('span', doc)))
            .append(this.rendererOverlay = createOne('div', doc).setAttr('class', 'rendererOverlay'))
            .append(this.golivebutton = createOne('div', doc).setAttr('class', 'liveButtonBox')))
          .append(this.devTools = createOne('div', doc)))
        .append(this.timeline = <TimelineView>new TimelineView(doc)))
      .append(this.sessionPlaybackSidebar = createOne('div', doc).setAttr('class', 'sessionPlaybackSidebar')
        .append(this.autoplay = <AutoplayView>new AutoplayView(doc))
        .append(this.eventListWrapper = createOne('div', doc).setAttr('class', 'eventListWrapper')
          .append(this.eventList = createOne('div', doc).setAttr('class', 'EventList'))))
      .append(this.tabs = createOne('div', doc).setAttr('class', 'sessionPlaybackTabs')
        .append(this.replayTab = createOne('div', doc).setAttr('class', 'tab replay active')
          .append(createOne('div', doc).setAttr('class', 'innerTab')
            .append(this.replayTabLabel = createOne('span', doc).setAttr('class', 'label'))))
        .append(this.insightsTab = createOne('div', doc).setAttr('class', 'tab insights')
          .append(createOne('div', doc).setAttr('class', 'innerTab')
            .append(this.insightsTabLabel = createOne('span', doc).setAttr('class', 'label')))));
  }
}



export class SliderView extends OfOne {
  thumb: OfOne;
  ghost: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SliderView')
      .append(this.thumb = createOne('div', doc).setAttr('class', 'thumb')
        .append(createOne('div', doc).setAttr('class', 'overlay')))
      .append(this.ghost = createOne('div', doc).setAttr('class', 'thumb ghost'));
  }
}



export class StdEventView extends OfOne {
  eventItemTrigger: OfOne;
  content: OfOne;
  actionType: OfOne;
  actionData: OfOne;
  textInput: OfOne;
  timeContainer: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'StdEvent hasMore')
      .append(this.eventItemTrigger = createOne('div', doc).setAttr('class', 'eiIcon'))
      .append(this.content = createOne('div', doc).setAttr('class', 'eiContent')
        .append(this.actionType = createOne('span', doc))
        .append(this.actionData = createOne('span', doc).setAttr('class', 'data')))
      .append(createOne('div', doc).setAttr('class', 'matchedText').appendText('event matches search criteria'))
      .append(this.textInput = createOne('textarea', doc).setAttr('readonly', 'readonly').setAttr('class', 'textInput data fs-block'))
      .append(this.timeContainer = createOne('div', doc));
  }
}



export class TimelineView extends OfOne {
  notesharepopup: OfOne;
  slider: OfOne;
  dingleblueberry: OfOne;
  inset: OfOne;
  sliderTrailer: OfOne;
  eventsContainer: OfOne;
  input: SliderView;
  controls: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'Timeline')
      .append(this.notesharepopup = createOne('div', doc))
      .append(this.slider = createOne('div', doc).setAttr('class', 'slider').setAttr('data-component', 'ProgressBar').setAttr('data-testid', 'timeline-progress-bar')
        .append(createOne('div', doc).setAttr('class', 'bg'))
        .append(this.dingleblueberry = createOne('div', doc).setAttr('class', 'dingleblueberry'))
        .append(this.inset = createOne('div', doc).setAttr('class', 'inset')
          .append(this.sliderTrailer = createOne('div', doc).setAttr('class', 'trailer'))
          .append(this.eventsContainer = createOne('div', doc)))
        .append(this.input = <SliderView>new SliderView(doc)))
      .append(this.controls = createOne('div', doc).setAttr('class', 'controls'));
  }
}



export class ViewOnlyHeaderView extends OfOne {
  title: OfOne;
  requestAccess: OfOne;
  logout: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ViewOnlyHeader')
      .append(this.title = createOne('span', doc).setAttr('class', 'message'))
      .append(this.requestAccess = createOne('span', doc).setAttr('class', 'cta cta-request-access'))
      .append(this.logout = createOne('span', doc).setAttr('class', 'cta cta-logout unButton'));
  }
}



export class MapKeyView extends OfOne {
  mapKeys: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'map-key')
      .append(createOne('div', doc).setAttr('class', 'map-keys-wrapper')
        .append(createOne('div', doc).setAttr('class', 'map-key-label').appendText('      clicks    '))
        .append(this.mapKeys = createOne('div', doc).setAttr('class', 'map-keys')));
  }
}



export class MaskerView extends OfOne {
  mask: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'masker')
      .append(createOne('svg', doc).setAttr('width', '100%').setAttr('height', '100%')
        .append(createOne('defs', doc)
          .append(this.mask = createOne('mask', doc).setAttr('id', 'mask').setAttr('maskUnits', 'userSpaceOnUse').setAttr('maskContentUnits', 'userSpaceOnUse')
            .append(createOne('rect', doc).setAttr('y', '0').setAttr('x', '0').setAttr('width', '100%').setAttr('height', '100%').setAttr('fill', 'white'))))
        .append(createOne('rect', doc).setAttr('y', '0').setAttr('x', '0').setAttr('width', '100%').setAttr('height', '100%').setAttr('fill', '#354553').setAttr('mask', 'url(#mask)')));
  }
}



export class OverlaysView extends OfOne {
  cursor: OfOne;
  touches: OfOne;
  inspector: OfOne;
  masker: MaskerView;
  highlights: OfOne;
  scrollmaps: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'overlays')
      .append(this.cursor = createOne('div', doc).setAttr('class', 'cursor'))
      .append(this.touches = createOne('div', doc).setAttr('class', 'touches'))
      .append(this.inspector = createOne('div', doc))
      .append(this.masker = <MaskerView>new MaskerView(doc))
      .append(this.highlights = createOne('div', doc).setAttr('class', 'highlights'))
      .append(this.scrollmaps = createOne('div', doc).setAttr('class', 'scrollmaps'));
  }
}



export class RankIndicatorView extends OfOne {
  content: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'RankIndicator animate')
      .append(this.content = createOne('div', doc).setAttr('class', 'content'));
  }
}



export class RendererView extends OfOne {
  mapKey: MapKeyView;
  scaled: OfOne;
  viewport: OfOne;
  frame: OfOne;
  overlays: OverlaysView;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'Renderer')
      .append(createOne('div', doc).setAttr('class', 'checkerboard'))
      .append(this.mapKey = <MapKeyView>new MapKeyView(doc))
      .append(createOne('div', doc).setAttr('class', 'fade'))
      .append(this.scaled = createOne('div', doc).setAttr('class', 'scaled')
        .append(this.viewport = createOne('div', doc).setAttr('class', 'viewport')
          .append(this.frame = createOne('div', doc).setAttr('class', 'playback-container').setAttr('style', 'overflow: hidden'))
          .append(this.overlays = <OverlaysView>new OverlaysView(doc))));
  }
}



export class TooltipView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'Tooltip');
  }
}



export class ActivityMapsView extends OfOne {
  reactAddDefinedEventOverlay: OfOne;
  reactAddWatchedElementOverlay: OfOne;
  reactFrustrationHeuristicsOverlay: OfOne;
  reactNameElementOverlay: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this
      .append(this.reactAddDefinedEventOverlay = createOne('div', doc).setAttr('class', 'reactAddDefinedEventOverlay'))
      .append(this.reactAddWatchedElementOverlay = createOne('div', doc).setAttr('class', 'reactAddWatchedElementOverlay'))
      .append(this.reactFrustrationHeuristicsOverlay = createOne('div', doc).setAttr('class', 'reactFrustrationHeuristicsOverlay'))
      .append(this.reactNameElementOverlay = createOne('div', doc).setAttr('class', 'reactNameElementOverlay'));
  }
}



export class ElemExplorerView extends OfOne {
  reactInspectMode: OfOne;
  reactAddNamedElementOverlay: OfOne;
  reactAddWatchedElementOverlay: OfOne;
  reactAddDefinedEventOverlay: OfOne;
  reactFrustrationHeuristicsOverlay: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'elemExplorer')
      .append(this.reactInspectMode = createOne('div', doc).setAttr('class', 'reactInspectMode'))
      .append(this.reactAddNamedElementOverlay = createOne('div', doc).setAttr('class', 'reactAddNamedElementOverlay'))
      .append(this.reactAddWatchedElementOverlay = createOne('div', doc).setAttr('class', 'reactAddWatchedElementOverlay'))
      .append(this.reactAddDefinedEventOverlay = createOne('div', doc).setAttr('class', 'reactAddDefinedEventOverlay'))
      .append(this.reactFrustrationHeuristicsOverlay = createOne('div', doc).setAttr('class', 'reactFrustrationHeuristicsOverlay'));
  }
}



export class ElemStatActionsView extends OfOne {
  search: OfOne;
  newSearch: OfOne;
  addToBlocks: OfOne;
  addToWatchesReact: OfOne;
  addToWatches: OfOne;
  addEventReact: OfOne;
  ignoreBehaviorSignals: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ElemStatActions')
      .append(this.search = createOne('button', doc).setAttr('class', 'search').appendText('Add to search'))
      .append(this.newSearch = createOne('button', doc).setAttr('class', 'newSearch').appendText('Create new search'))
      .append(this.addToBlocks = createOne('button', doc).setAttr('class', 'addToBlocks').appendText('Modify data capture rules'))
      .append(this.addToWatchesReact = createOne('div', doc))
      .append(this.addToWatches = createOne('button', doc).setAttr('class', 'addToWatches').appendText('Watch element'))
      .append(this.addEventReact = createOne('div', doc))
      .append(this.ignoreBehaviorSignals = createOne('div', doc));
  }
}



export class ElemStatsView extends OfOne {
  selector: OfOne;
  secondary: OfOne;
  actions: ElemStatActionsView;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'ElemStats')
      .append(this.selector = createOne('div', doc).setAttr('class', 'selector ElemStat'))
      .append(this.secondary = createOne('div', doc).setAttr('class', 'secondary'))
      .append(this.actions = <ElemStatActionsView>new ElemStatActionsView(doc));
  }
}



export class PageInsightsView extends OfOne {
  tabs: OfOne;
  tabClickMaps: OfOne;
  tabClickMapsTxt: OfOne;
  tabScrollMaps: OfOne;
  scrollMapsTxt: OfOne;
  tabElemExplore: OfOne;
  tabContent: OfOne;
  clickMaps: ActivityMapsView;
  scrollMaps: ScrollMapsView;
  elemExplorer: ElemExplorerView;
  recordingRulesModal: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'PageInsightsPanel')
      .append(this.tabs = createOne('div', doc).setAttr('class', 'tabs')
        .append(this.tabClickMaps = createOne('div', doc).setAttr('class', 'tab activityMaps active')
          .append(this.tabClickMapsTxt = createOne('span', doc))
          .append(createOne('content', doc).setAttr('src', '')))
        .append(this.tabScrollMaps = createOne('div', doc).setAttr('class', 'tab scrollMaps')
          .append(this.scrollMapsTxt = createOne('span', doc))
          .append(createOne('content', doc).setAttr('src', '')))
        .append(this.tabElemExplore = createOne('div', doc).setAttr('class', 'tab elemExplore')))
      .append(this.tabContent = createOne('div', doc).setAttr('class', 'tabContent')
        .append(this.clickMaps = <ActivityMapsView>new ActivityMapsView(doc).setAttr('class', 'activityMaps panel'))
        .append(this.scrollMaps = <ScrollMapsView>new ScrollMapsView(doc).setAttr('class', 'scrollMaps panel'))
        .append(this.elemExplorer = <ElemExplorerView>new ElemExplorerView(doc).setAttr('class', 'elemExplorer panel')))
      .append(this.recordingRulesModal = createOne('div', doc));
  }
}



export class ScrollMapsView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this;
  }
}



export class CustomDatesView extends OfOne {
  from: OfOne;
  to: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'customDates')
      .append(this.from = createOne('input', doc).setAttr('type', 'text').setAttr('class', 'textInput right'))
      .append(createOne('span', doc).setAttr('class', 'to').appendText('to'))
      .append(this.to = createOne('input', doc).setAttr('type', 'text').setAttr('class', 'textInput'));
  }
}



export class DatePickerView extends OfOne {
  dateOptions: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DatePicker')
      .append(this.dateOptions = createOne('div', doc).setAttr('class', 'dateOptions'));
  }
}



export class DigestToolTipView extends OfOne {
  settingsBtn: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'DigestToolTip').appendText('  Frequency can be modified in ')
      .append(this.settingsBtn = createOne('span', doc).setAttr('class', 'linkLike').appendText('Notification Settings')).appendText('.');
  }
}



export class QuotaBarView extends OfOne {
  used: OfOne;
  usedLabel: OfOne;
  totalLabel: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'quotaBar')
      .append(this.used = createOne('div', doc).setAttr('class', 'used'))
      .append(createOne('span', doc).setAttr('class', 'label')
        .append(this.usedLabel = createOne('span', doc)).appendText('/')
        .append(this.totalLabel = createOne('span', doc)));
  }
}



export class GtmDialogView extends OfOne {
  head: OfOne;
  icon: OfOne;
  content: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'GtmDialog')
      .append(this.head = createOne('div', doc).setAttr('class', 'head')
        .append(this.icon = createOne('div', doc).setAttr('class', 'icon'))
        .append(createOne('div', doc).setAttr('class', 'title').appendText('Record with Google Tag Manager.')))
      .append(this.content = createOne('div', doc).setAttr('class', 'content'));
  }
}



export class GraphTooltipView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('span'));

    this.setAttr('class', 'tooltip');
  }
}



export class GraphTooltipRowView extends OfOne {
  color: OfOne;
  left: OfOne;
  right: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'tooltipRow')
      .append(this.color = createOne('div', doc).setAttr('class', 'color'))
      .append(this.left = createOne('span', doc).setAttr('class', 'left'))
      .append(createOne('span', doc).setAttr('class', 'dot'))
      .append(this.right = createOne('span', doc).setAttr('class', 'right'));
  }
}



export class MultiGraphRowView extends OfOne {
  info: OfOne;
  icon: OfOne;
  callout: OfOne;
  tagline: OfOne;
  chart: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'MultiGraphRow')
      .append(this.info = createOne('div', doc).setAttr('class', 'info')
        .append(createOne('div', doc).setAttr('class', 'top')
          .append(this.icon = createOne('div', doc).setAttr('class', 'icon'))
          .append(this.callout = createOne('div', doc).setAttr('class', 'callout')))
        .append(this.tagline = createOne('div', doc).setAttr('class', 'tagline')))
      .append(this.chart = createOne('div', doc).setAttr('class', 'chart'));
  }
}



export class SearchieSettingCheckboxView extends OfOne {
  checkbox: OfOne;
  label: OfOne;
  sublabel: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SearchieSettingCheckbox')
      .append(this.checkbox = createOne('input', doc).setAttr('type', 'checkbox'))
      .append(createOne('div', doc).setAttr('class', 'text')
        .append(this.label = createOne('label', doc))
        .append(this.sublabel = createOne('div', doc).setAttr('class', 'sublabel')));
  }
}



export class SearchieSettingRadioButtonView extends OfOne {
  radio: OfOne;
  label: OfOne;
  sublabel: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'SearchieSettingRadioButton')
      .append(this.radio = createOne('input', doc).setAttr('type', 'radio'))
      .append(createOne('div', doc).setAttr('class', 'text')
        .append(this.label = createOne('label', doc))
        .append(this.sublabel = createOne('div', doc).setAttr('class', 'sublabel')));
  }
}



export class OnboardingNavView extends OfOne {
  wizardNavBarBasic: OfOne;
  wizardNavBar: OfOne;
  helpDiv: OfOne;
  help: OfOne;
  logout: OfOne;
  wizardPage: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'wizard')
      .append(createOne('div', doc).setAttr('class', 'w-nav')
        .append(this.wizardNavBarBasic = createOne('div', doc).setAttr('class', 'hidden')
          .append(createOne('div', doc).setAttr('class', 'w-back-arrow')))
        .append(createOne('div', doc).setAttr('class', 'w-nav-box')
          .append(createOne('img', doc).setAttr('src', '/s/img/wizard/w-icon-logo.svg')))
        .append(this.wizardNavBar = createOne('div', doc).setAttr('class', 'w-nav-steps hidden'))
        .append(createOne('div', doc).setAttr('class', 'w-nav-box w-nav-links right separated')
          .append(this.helpDiv = createOne('div', doc).setAttr('class', 'w-nav-link')
            .append(this.help = createOne('button', doc).setAttr('class', 'linkButton helpBtn')))
          .append(this.logout = createOne('a', doc).setAttr('href', '/logout').setAttr('class', 'w-nav-link'))))
      .append(this.wizardPage = createOne('div', doc).setAttr('class', 'wizard-page'));
  }
}



export class OnboardingNavSegmentView extends OfOne {
  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'w-nav-step');
  }
}



export class PersonaCellSmView extends OfOne {
  img: OfOne;
  title: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'w-icocheck is-checked')
      .append(this.img = createOne('div', doc).setAttr('class', 'w-icocheck-icon'))
      .append(this.title = createOne('div', doc).setAttr('class', 'w-icocheck-text'));
  }
}



export class AccountSetupView extends OfOne {
  titleTxt1: OfOne;
  name: OfOne;
  titleTxt2: OfOne;
  subtitleTxt: OfOne;
  nameLabel: OfOne;
  companyName: OfOne;
  domainLabel: OfOne;
  domain: OfOne;
  sizeLabel: OfOne;
  companySelect: OfOne;
  companySize: OfOne;
  industryLabel: OfOne;
  industrySelect: OfOne;
  companyType: OfOne;
  nextBtn: OfOne;
  backBtn: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'w-slide')
      .append(createOne('div', doc).setAttr('class', 'w-head')
        .append(createOne('div', doc).setAttr('class', 'w-title')
          .append(this.titleTxt1 = createOne('span', doc)).appendText(' ')
          .append(this.name = createOne('span', doc))
          .append(this.titleTxt2 = createOne('span', doc)))
        .append(this.subtitleTxt = createOne('div', doc).setAttr('class', 'w-subtitle')))
      .append(createOne('div', doc).setAttr('class', 'w-content')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(this.nameLabel = createOne('div', doc).setAttr('class', 'w-form-label')))
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(createOne('div', doc).setAttr('class', 'w-form-control')
              .append(this.companyName = createOne('input', doc).setAttr('type', 'text').setAttr('class', 'w-form-input company')))))
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(this.domainLabel = createOne('div', doc).setAttr('class', 'w-form-label')))
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(createOne('div', doc).setAttr('class', 'w-form-control domain-control')
              .append(createOne('span', doc).appendText('https://'))
              .append(this.domain = createOne('input', doc).setAttr('type', 'text').setAttr('class', 'w-form-input domain')))))
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(this.sizeLabel = createOne('div', doc).setAttr('class', 'w-form-label')))
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(createOne('div', doc).setAttr('class', 'w-form-control')
              .append(this.companySelect = createOne('select', doc).setAttr('class', 'w-form-select')
                .append(this.companySize = createOne('option', doc).setAttr('value', '').setAttr('disabled', '').setAttr('selected', ''))))))
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(this.industryLabel = createOne('div', doc).setAttr('class', 'w-form-label')))
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(createOne('div', doc).setAttr('class', 'w-form-control')
              .append(this.industrySelect = createOne('select', doc).setAttr('class', 'w-form-select')
                .append(this.companyType = createOne('option', doc).setAttr('value', '').setAttr('disabled', '').setAttr('selected', '')))))))
      .append(createOne('div', doc).setAttr('class', 'w-foot')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-half-ns offset w-col-full-s')
            .append(this.nextBtn = createOne('div', doc).setAttr('class', 'w-cta'))
            .append(this.backBtn = createOne('div', doc).setAttr('class', 'w-cta secondary')))));
  }
}



export class PrivacyView extends OfOne {
  title: OfOne;
  subtitle: OfOne;
  image: OfOne;
  copy: OfOne;
  nextBtn: OfOne;
  freeFlipFinePrint: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'w-slide')
      .append(createOne('div', doc).setAttr('class', 'w-head')
        .append(this.title = createOne('div', doc).setAttr('class', 'w-title'))
        .append(this.subtitle = createOne('div', doc).setAttr('class', 'w-subtitle')))
      .append(createOne('div', doc).setAttr('class', 'w-content')
        .append(createOne('div', doc).setAttr('class', 'w-copy centered')
          .append(this.image = createOne('img', doc).setAttr('class', 'w-img-hero').setAttr('src', '/s/img/wizard/w-hero-exclude-alt.png')))
        .append(this.copy = createOne('p', doc).setAttr('class', 'w-copy centered')))
      .append(createOne('div', doc).setAttr('class', 'w-foot')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-half offset w-col-full-s')
            .append(this.nextBtn = createOne('div', doc).setAttr('class', 'w-cta nudge-top'))))
        .append(this.freeFlipFinePrint = createOne('div', doc).setAttr('class', 'w-fine-print centered'))
        .append(createOne('div', doc).setAttr('class', 'w-heart little')));
  }
}



export class ProfileSetupView extends OfOne {
  title: OfOne;
  subtitle: OfOne;
  nameLabel: OfOne;
  firstName: OfOne;
  lastName: OfOne;
  roleLabel: OfOne;
  leftPersonaColumn: OfOne;
  rightPersonaColumn: OfOne;
  nextBtn: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'w-slide')
      .append(createOne('div', doc).setAttr('class', 'w-head')
        .append(this.title = createOne('div', doc).setAttr('class', 'w-title'))
        .append(this.subtitle = createOne('div', doc).setAttr('class', 'w-subtitle')))
      .append(createOne('div', doc).setAttr('class', 'w-content')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(this.nameLabel = createOne('div', doc).setAttr('class', 'w-form-label')))
          .append(createOne('div', doc).setAttr('class', 'w-col-half w-col-full-s')
            .append(createOne('div', doc).setAttr('class', 'w-form-control')
              .append(this.firstName = createOne('input', doc).setAttr('type', 'text').setAttr('class', 'w-form-input'))))
          .append(createOne('div', doc).setAttr('class', 'w-col-half w-col-full-s')
            .append(createOne('div', doc).setAttr('class', 'w-form-control')
              .append(this.lastName = createOne('input', doc).setAttr('type', 'text').setAttr('class', 'w-form-input')))))
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-full')
            .append(this.roleLabel = createOne('div', doc).setAttr('class', 'w-form-label')))
          .append(createOne('div', doc).setAttr('class', 'w-col-full w-col-half-ns')
            .append(this.leftPersonaColumn = createOne('div', doc).setAttr('class', 'w-form-control w-icochecks')))
          .append(createOne('div', doc).setAttr('class', 'w-col-full w-col-half-ns')
            .append(this.rightPersonaColumn = createOne('div', doc).setAttr('class', 'w-form-control w-icochecks')))))
      .append(createOne('div', doc).setAttr('class', 'w-foot')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-half-ns offset w-col-full-s')
            .append(this.nextBtn = createOne('div', doc).setAttr('class', 'w-cta')))));
  }
}



export class RecordingSetupView extends OfOne {
  title: OfOne;
  subtitle: OfOne;
  accordion: OfOne;
  nextBtn: OfOne;
  backBtn: OfOne;

  constructor(doc: Document = document) {
    super(doc.createElement('div'));

    this.setAttr('class', 'w-slide')
      .append(createOne('div', doc).setAttr('class', 'w-head')
        .append(this.title = createOne('div', doc).setAttr('class', 'w-title'))
        .append(this.subtitle = createOne('div', doc).setAttr('class', 'w-subtitle')))
      .append(createOne('div', doc).setAttr('class', 'w-content')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(this.accordion = createOne('div', doc).setAttr('class', 'w-col-full'))))
      .append(createOne('div', doc).setAttr('class', 'w-foot')
        .append(createOne('div', doc).setAttr('class', 'w-row')
          .append(createOne('div', doc).setAttr('class', 'w-col-half-ns offset w-col-full-s')
            .append(this.nextBtn = createOne('div', doc).setAttr('class', 'w-cta'))
            .append(this.backBtn = createOne('div', doc).setAttr('class', 'w-cta secondary')))));
  }
}


